//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class Client {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * Validate and update scanned barcode list
     * @param body (optional) 
     * @return Success
     */
    confirmItemsReceived(body: UpdateBarcodeListCommandArguments | undefined, cancelToken?: CancelToken | undefined): Promise<ConfirmItemsReceivedCommandResponse> {
        let url_ = this.baseUrl + "/api/Barcode/ConfirmItemsReceived";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConfirmItemsReceived(_response);
        });
    }

    protected processConfirmItemsReceived(response: AxiosResponse): Promise<ConfirmItemsReceivedCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ConfirmItemsReceivedCommandResponse.fromJS(resultData200);
            return Promise.resolve<ConfirmItemsReceivedCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConfirmItemsReceivedCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    takeItemOutOfCirculation(body: UpdateBarcodeListCommandArguments | undefined, cancelToken?: CancelToken | undefined): Promise<TakeItemOutOfCirculationCommandResponse> {
        let url_ = this.baseUrl + "/api/Barcode/TakeItemOutOfCirculation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTakeItemOutOfCirculation(_response);
        });
    }

    protected processTakeItemOutOfCirculation(response: AxiosResponse): Promise<TakeItemOutOfCirculationCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TakeItemOutOfCirculationCommandResponse.fromJS(resultData200);
            return Promise.resolve<TakeItemOutOfCirculationCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TakeItemOutOfCirculationCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePorterByBarcode(body: ChangePorterByBarcodeCommandArguments | undefined, cancelToken?: CancelToken | undefined): Promise<ChangePorterByBarcodeCommandResponse> {
        let url_ = this.baseUrl + "/api/Barcode/ChangePorterByBarcode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangePorterByBarcode(_response);
        });
    }

    protected processChangePorterByBarcode(response: AxiosResponse): Promise<ChangePorterByBarcodeCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChangePorterByBarcodeCommandResponse.fromJS(resultData200);
            return Promise.resolve<ChangePorterByBarcodeCommandResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangePorterByBarcodeCommandResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    downloadScannedBarcodes(body: DownloadBarcodeListRequestArguments | undefined, cancelToken?: CancelToken | undefined): Promise<DownloadBarcodeListResponse> {
        let url_ = this.baseUrl + "/api/Barcode/DownloadScannedBarcodes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadScannedBarcodes(_response);
        });
    }

    protected processDownloadScannedBarcodes(response: AxiosResponse): Promise<DownloadBarcodeListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DownloadBarcodeListResponse.fromJS(resultData200);
            return Promise.resolve<DownloadBarcodeListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DownloadBarcodeListResponse>(null as any);
    }

    /**
     * @param creditMemoNumber (optional) 
     * @return Success
     */
    getCreditMemos(creditMemoNumber: string | undefined, cancelToken?: CancelToken | undefined): Promise<CreditMemo[]> {
        let url_ = this.baseUrl + "/api/CreditMemos/GetCreditMemos?";
        if (creditMemoNumber === null)
            throw new Error("The parameter 'creditMemoNumber' cannot be null.");
        else if (creditMemoNumber !== undefined)
            url_ += "creditMemoNumber=" + encodeURIComponent("" + creditMemoNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCreditMemos(_response);
        });
    }

    protected processGetCreditMemos(response: AxiosResponse): Promise<CreditMemo[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreditMemo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CreditMemo[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreditMemo[]>(null as any);
    }

    /**
     * @param creditMemoNumber (optional) 
     * @return Success
     */
    getCreditMemoLines(creditMemoNumber: string | undefined, cancelToken?: CancelToken | undefined): Promise<CreditMemoLine[]> {
        let url_ = this.baseUrl + "/api/CreditMemos/GetCreditMemoLines?";
        if (creditMemoNumber === null)
            throw new Error("The parameter 'creditMemoNumber' cannot be null.");
        else if (creditMemoNumber !== undefined)
            url_ += "creditMemoNumber=" + encodeURIComponent("" + creditMemoNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCreditMemoLines(_response);
        });
    }

    protected processGetCreditMemoLines(response: AxiosResponse): Promise<CreditMemoLine[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreditMemoLine.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CreditMemoLine[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreditMemoLine[]>(null as any);
    }

    /**
     * @param mutationCode (optional) 
     * @return Success
     */
    getLocationsByMutation(mutationCode: string | undefined, cancelToken?: CancelToken | undefined): Promise<MutationLocation[]> {
        let url_ = this.baseUrl + "/api/Customer/GetLocationsByMutation?";
        if (mutationCode === null)
            throw new Error("The parameter 'mutationCode' cannot be null.");
        else if (mutationCode !== undefined)
            url_ += "mutationCode=" + encodeURIComponent("" + mutationCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLocationsByMutation(_response);
        });
    }

    protected processGetLocationsByMutation(response: AxiosResponse): Promise<MutationLocation[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MutationLocation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MutationLocation[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MutationLocation[]>(null as any);
    }

    /**
     * Get customers connected to the email.
     * @param email (optional) 
     * @return Success
     */
    getCustomersByEmail(email: string | undefined, cancelToken?: CancelToken | undefined): Promise<GetCustomersByEmailViewModel> {
        let url_ = this.baseUrl + "/api/Customer/GetCustomersByEmail?";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomersByEmail(_response);
        });
    }

    protected processGetCustomersByEmail(response: AxiosResponse): Promise<GetCustomersByEmailViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCustomersByEmailViewModel.fromJS(resultData200);
            return Promise.resolve<GetCustomersByEmailViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCustomersByEmailViewModel>(null as any);
    }

    /**
     * @param documentType (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @param porters (optional) 
     * @param statusCode (optional) 
     * @param email (optional) 
     * @return Success
     */
    getDocument(documentType: DocumentType | undefined, from: Date | null | undefined, to: Date | null | undefined, porters: string[] | undefined, statusCode: string | undefined, email: string | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/CustomerCenter/GetDocument?";
        if (documentType === null)
            throw new Error("The parameter 'documentType' cannot be null.");
        else if (documentType !== undefined)
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&";
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (porters === null)
            throw new Error("The parameter 'porters' cannot be null.");
        else if (porters !== undefined)
            porters && porters.forEach(item => { url_ += "porters=" + encodeURIComponent("" + item) + "&"; });
        if (statusCode === null)
            throw new Error("The parameter 'statusCode' cannot be null.");
        else if (statusCode !== undefined)
            url_ += "statusCode=" + encodeURIComponent("" + statusCode) + "&";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDocument(_response);
        });
    }

    protected processGetDocument(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param documentType (optional) 
     * @param linkId (optional) 
     * @param orderEmail (optional) 
     * @return Success
     */
    downloadPdf(documentType: DocumentType2 | undefined, linkId: string | undefined, orderEmail: string | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/CustomerCenter/DownloadPdf?";
        if (documentType === null)
            throw new Error("The parameter 'documentType' cannot be null.");
        else if (documentType !== undefined)
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&";
        if (linkId === null)
            throw new Error("The parameter 'linkId' cannot be null.");
        else if (linkId !== undefined)
            url_ += "linkId=" + encodeURIComponent("" + linkId) + "&";
        if (orderEmail === null)
            throw new Error("The parameter 'orderEmail' cannot be null.");
        else if (orderEmail !== undefined)
            url_ += "orderEmail=" + encodeURIComponent("" + orderEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadPdf(_response);
        });
    }

    protected processDownloadPdf(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getCustomerBarcodeStatusCodes( cancelToken?: CancelToken | undefined): Promise<CustomerBarcodeStatusCode[]> {
        let url_ = this.baseUrl + "/api/CustomerCenter/GetCustomerBarcodeStatusCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomerBarcodeStatusCodes(_response);
        });
    }

    protected processGetCustomerBarcodeStatusCodes(response: AxiosResponse): Promise<CustomerBarcodeStatusCode[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerBarcodeStatusCode.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CustomerBarcodeStatusCode[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerBarcodeStatusCode[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUserInfo(body: UpdateUserInfoRequestArgs | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/CustomerCenter/UpdateUserInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUserInfo(_response);
        });
    }

    protected processUpdateUserInfo(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getUserInfo( cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/CustomerCenter/GetUserInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserInfo(_response);
        });
    }

    protected processGetUserInfo(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param search (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @param languageCode (optional) 
     * @return Success
     */
    getInvoices(search: string | undefined, from: Date | null | undefined, to: Date | null | undefined, languageCode: string | undefined, cancelToken?: CancelToken | undefined): Promise<GetInvoicesViewModel> {
        let url_ = this.baseUrl + "/api/MireilleInvoices/GetInvoices?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (languageCode === null)
            throw new Error("The parameter 'languageCode' cannot be null.");
        else if (languageCode !== undefined)
            url_ += "LanguageCode=" + encodeURIComponent("" + languageCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoices(_response);
        });
    }

    protected processGetInvoices(response: AxiosResponse): Promise<GetInvoicesViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetInvoicesViewModel.fromJS(resultData200);
            return Promise.resolve<GetInvoicesViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetInvoicesViewModel>(null as any);
    }

    /**
     * @param languageCode (optional) 
     * @param porterNo (optional) 
     * @return Success
     */
    getRecentOrders(languageCode: string | undefined, porterNo: string | undefined, cancelToken?: CancelToken | undefined): Promise<GetRecentOrdersViewModel> {
        let url_ = this.baseUrl + "/api/MireilleInvoices/GetRecentOrders?";
        if (languageCode === null)
            throw new Error("The parameter 'languageCode' cannot be null.");
        else if (languageCode !== undefined)
            url_ += "LanguageCode=" + encodeURIComponent("" + languageCode) + "&";
        if (porterNo === null)
            throw new Error("The parameter 'porterNo' cannot be null.");
        else if (porterNo !== undefined)
            url_ += "PorterNo=" + encodeURIComponent("" + porterNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRecentOrders(_response);
        });
    }

    protected processGetRecentOrders(response: AxiosResponse): Promise<GetRecentOrdersViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetRecentOrdersViewModel.fromJS(resultData200);
            return Promise.resolve<GetRecentOrdersViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRecentOrdersViewModel>(null as any);
    }

    /**
     * @param linkId (optional) 
     * @return Success
     */
    getInvoice(linkId: string | undefined, cancelToken?: CancelToken | undefined): Promise<GetInvoiceViewModel> {
        let url_ = this.baseUrl + "/api/MireilleInvoices/GetInvoice?";
        if (linkId === null)
            throw new Error("The parameter 'linkId' cannot be null.");
        else if (linkId !== undefined)
            url_ += "linkId=" + encodeURIComponent("" + linkId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoice(_response);
        });
    }

    protected processGetInvoice(response: AxiosResponse): Promise<GetInvoiceViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetInvoiceViewModel.fromJS(resultData200);
            return Promise.resolve<GetInvoiceViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetInvoiceViewModel>(null as any);
    }

    /**
     * @param linkId (optional) 
     * @return Success
     */
    getInvoicePdf(linkId: string | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/MireilleInvoices/GetInvoicePdf?";
        if (linkId === null)
            throw new Error("The parameter 'linkId' cannot be null.");
        else if (linkId !== undefined)
            url_ += "linkId=" + encodeURIComponent("" + linkId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoicePdf(_response);
        });
    }

    protected processGetInvoicePdf(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getNavErrors( cancelToken?: CancelToken | undefined): Promise<NavError[]> {
        let url_ = this.baseUrl + "/api/NavErrors/GetNavErrors";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNavErrors(_response);
        });
    }

    protected processGetNavErrors(response: AxiosResponse): Promise<NavError[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NavError.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<NavError[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NavError[]>(null as any);
    }

    /**
     * @return Success
     */
    getLatestNavError( cancelToken?: CancelToken | undefined): Promise<NavError> {
        let url_ = this.baseUrl + "/api/NavErrors/GetLatestNavError";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLatestNavError(_response);
        });
    }

    protected processGetLatestNavError(response: AxiosResponse): Promise<NavError> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NavError.fromJS(resultData200);
            return Promise.resolve<NavError>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NavError>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteNavError(id: number | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/NavErrors/DeleteNavError?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteNavError(_response);
        });
    }

    protected processDeleteNavError(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getPendingOrders( cancelToken?: CancelToken | undefined): Promise<GetPendingOrdersViewModel> {
        let url_ = this.baseUrl + "/api/Order/GetPendingOrders";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPendingOrders(_response);
        });
    }

    protected processGetPendingOrders(response: AxiosResponse): Promise<GetPendingOrdersViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPendingOrdersViewModel.fromJS(resultData200);
            return Promise.resolve<GetPendingOrdersViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPendingOrdersViewModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    acceptPendingOrder(body: AcceptPendingOrderArgs | undefined, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Order/AcceptPendingOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcceptPendingOrder(_response);
        });
    }

    protected processAcceptPendingOrder(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    rejectPendingOrder(body: RejectPendingOrderArgs | undefined, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Order/RejectPendingOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRejectPendingOrder(_response);
        });
    }

    protected processRejectPendingOrder(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    requestModifyPendingOrder(body: RequestModifyPendingOrderArgs | undefined, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Order/RequestModifyPendingOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRequestModifyPendingOrder(_response);
        });
    }

    protected processRequestModifyPendingOrder(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return Success
     */
    getPorterList( cancelToken?: CancelToken | undefined): Promise<PorterListViewModel> {
        let url_ = this.baseUrl + "/api/Porter/GetPorterList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPorterList(_response);
        });
    }

    protected processGetPorterList(response: AxiosResponse): Promise<PorterListViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PorterListViewModel.fromJS(resultData200);
            return Promise.resolve<PorterListViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PorterListViewModel>(null as any);
    }

    /**
     * @return Success
     */
    getPorterListForShipping( cancelToken?: CancelToken | undefined): Promise<PorterListViewModel> {
        let url_ = this.baseUrl + "/api/Porter/GetPorterListForShipping";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPorterListForShipping(_response);
        });
    }

    protected processGetPorterListForShipping(response: AxiosResponse): Promise<PorterListViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PorterListViewModel.fromJS(resultData200);
            return Promise.resolve<PorterListViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PorterListViewModel>(null as any);
    }

    /**
     * @return Success
     */
    getOrganizationPorters( cancelToken?: CancelToken | undefined): Promise<PorterListViewModel> {
        let url_ = this.baseUrl + "/api/Porter/GetOrganizationPorters";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganizationPorters(_response);
        });
    }

    protected processGetOrganizationPorters(response: AxiosResponse): Promise<PorterListViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PorterListViewModel.fromJS(resultData200);
            return Promise.resolve<PorterListViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PorterListViewModel>(null as any);
    }

    /**
     * Returns list of available generic fields for customers porters
     * @return Success
     */
    getPorterFieldList( cancelToken?: CancelToken | undefined): Promise<PorterFieldListViewModel> {
        let url_ = this.baseUrl + "/api/Porter/GetPorterFieldList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPorterFieldList(_response);
        });
    }

    protected processGetPorterFieldList(response: AxiosResponse): Promise<PorterFieldListViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PorterFieldListViewModel.fromJS(resultData200);
            return Promise.resolve<PorterFieldListViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PorterFieldListViewModel>(null as any);
    }

    /**
     * Returns list of available generic fields for customers porters
     * @param customerNo (optional) 
     * @return Success
     */
    getPorterFieldListByCustomer(customerNo: string | undefined, cancelToken?: CancelToken | undefined): Promise<PorterFieldListViewModel> {
        let url_ = this.baseUrl + "/api/Porter/GetPorterFieldListByCustomer?";
        if (customerNo === null)
            throw new Error("The parameter 'customerNo' cannot be null.");
        else if (customerNo !== undefined)
            url_ += "customerNo=" + encodeURIComponent("" + customerNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPorterFieldListByCustomer(_response);
        });
    }

    protected processGetPorterFieldListByCustomer(response: AxiosResponse): Promise<PorterFieldListViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PorterFieldListViewModel.fromJS(resultData200);
            return Promise.resolve<PorterFieldListViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PorterFieldListViewModel>(null as any);
    }

    /**
     * Returns a single Porter
     * @param id (optional) 
     * @return Success
     */
    getPorterById(id: string | undefined, cancelToken?: CancelToken | undefined): Promise<GetPorterViewModel> {
        let url_ = this.baseUrl + "/api/Porter/GetPorterById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPorterById(_response);
        });
    }

    protected processGetPorterById(response: AxiosResponse): Promise<GetPorterViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPorterViewModel.fromJS(resultData200);
            return Promise.resolve<GetPorterViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPorterViewModel>(null as any);
    }

    /**
     * Returns a single Porter
     * @param id (optional) 
     * @return Success
     */
    getPorterByNo(id: string | undefined, cancelToken?: CancelToken | undefined): Promise<GetPorterViewModel> {
        let url_ = this.baseUrl + "/api/Porter/GetPorterByNo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPorterByNo(_response);
        });
    }

    protected processGetPorterByNo(response: AxiosResponse): Promise<GetPorterViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPorterViewModel.fromJS(resultData200);
            return Promise.resolve<GetPorterViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPorterViewModel>(null as any);
    }

    /**
     * Gets the porter budget.
     * @param porterUserName (optional) 
     * @return Success
     */
    getPorterBudget(porterUserName: string | undefined, cancelToken?: CancelToken | undefined): Promise<GetPorterBudgetViewModel> {
        let url_ = this.baseUrl + "/api/Porter/GetPorterBudget?";
        if (porterUserName === null)
            throw new Error("The parameter 'porterUserName' cannot be null.");
        else if (porterUserName !== undefined)
            url_ += "porterUserName=" + encodeURIComponent("" + porterUserName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPorterBudget(_response);
        });
    }

    protected processGetPorterBudget(response: AxiosResponse): Promise<GetPorterBudgetViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPorterBudgetViewModel.fromJS(resultData200);
            return Promise.resolve<GetPorterBudgetViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPorterBudgetViewModel>(null as any);
    }

    /**
     * Gets the porter budget.
     * @return Success
     */
    getPorterBudgetsByCustomerNumber( cancelToken?: CancelToken | undefined): Promise<GetPorterBudgetsByCustomerNumberViewModel> {
        let url_ = this.baseUrl + "/api/Porter/GetPorterBudgetsByCustomerNumber";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPorterBudgetsByCustomerNumber(_response);
        });
    }

    protected processGetPorterBudgetsByCustomerNumber(response: AxiosResponse): Promise<GetPorterBudgetsByCustomerNumberViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPorterBudgetsByCustomerNumberViewModel.fromJS(resultData200);
            return Promise.resolve<GetPorterBudgetsByCustomerNumberViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPorterBudgetsByCustomerNumberViewModel>(null as any);
    }

    /**
     * Gets the porter budget.
     * @param languageId (optional) 
     * @param id (optional) 
     * @return Success
     */
    getPorterProductListItems(languageId: string | undefined, id: string | undefined, cancelToken?: CancelToken | undefined): Promise<GetPorterProductListItemsViewModel> {
        let url_ = this.baseUrl + "/api/Porter/GetPorterProductListItems?";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPorterProductListItems(_response);
        });
    }

    protected processGetPorterProductListItems(response: AxiosResponse): Promise<GetPorterProductListItemsViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPorterProductListItemsViewModel.fromJS(resultData200);
            return Promise.resolve<GetPorterProductListItemsViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPorterProductListItemsViewModel>(null as any);
    }

    /**
     * Gets the porter function.
    TODO: REGISTER SERVICE
     * @param customerNo (optional) 
     * @return Success
     */
    getPorterFunction(customerNo: string | undefined, cancelToken?: CancelToken | undefined): Promise<GetPorterFunctionViewModel> {
        let url_ = this.baseUrl + "/api/Porter/GetPorterFunction?";
        if (customerNo === null)
            throw new Error("The parameter 'customerNo' cannot be null.");
        else if (customerNo !== undefined)
            url_ += "customerNo=" + encodeURIComponent("" + customerNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPorterFunction(_response);
        });
    }

    protected processGetPorterFunction(response: AxiosResponse): Promise<GetPorterFunctionViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPorterFunctionViewModel.fromJS(resultData200);
            return Promise.resolve<GetPorterFunctionViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPorterFunctionViewModel>(null as any);
    }

    /**
     * Gets the porter item.
    TODO: REGISTER SERVICE
     * @return Success
     */
    getPorterItem( cancelToken?: CancelToken | undefined): Promise<GetPorterBudgetViewModel> {
        let url_ = this.baseUrl + "/api/Porter/GetPorterItem";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPorterItem(_response);
        });
    }

    protected processGetPorterItem(response: AxiosResponse): Promise<GetPorterBudgetViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPorterBudgetViewModel.fromJS(resultData200);
            return Promise.resolve<GetPorterBudgetViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPorterBudgetViewModel>(null as any);
    }

    /**
     * Updates a given Porter
     * @param body (optional) 
     * @return Success
     */
    updatePorter(body: UpdatePorterCommandArguments | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Porter/UpdatePorter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePorter(_response);
        });
    }

    protected processUpdatePorter(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Creates a Porter
     * @param body (optional) 
     * @return Success
     */
    createPorter(body: CreatePorterCommandArguments | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Porter/CreatePorter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePorter(_response);
        });
    }

    protected processCreatePorter(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Retires a Porter
     * @param languageId (optional) 
     * @param body (optional) 
     * @return Success
     */
    retirePorter(languageId: string | undefined, body: PorterKey | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Porter/RetirePorter?";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRetirePorter(_response);
        });
    }

    protected processRetirePorter(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Moves a porter to another Customer (Location)
     * @param body (optional) 
     * @return Success
     */
    movePorter(body: MovePorterCommandArguments | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Porter/MovePorter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMovePorter(_response);
        });
    }

    protected processMovePorter(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param languageId (optional) 
     * @param id (optional) 
     * @return Success
     */
    getPorterItems(languageId: string | undefined, id: string | undefined, cancelToken?: CancelToken | undefined): Promise<GetPorterItemListViewModel> {
        let url_ = this.baseUrl + "/api/PorterItems/GetPorterItems?";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPorterItems(_response);
        });
    }

    protected processGetPorterItems(response: AxiosResponse): Promise<GetPorterItemListViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPorterItemListViewModel.fromJS(resultData200);
            return Promise.resolve<GetPorterItemListViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPorterItemListViewModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePorterItem(body: UpdatePorterItemCommandArguments | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/PorterItems/UpdatePorterItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePorterItem(_response);
        });
    }

    protected processUpdatePorterItem(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deletePorterItem(body: DeletePorterItemCommandArguments | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/PorterItems/DeletePorterItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePorterItem(_response);
        });
    }

    protected processDeletePorterItem(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPorterItem(body: CreatePorterItemCommandArguments | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/PorterItems/CreatePorterItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePorterItem(_response);
        });
    }

    protected processCreatePorterItem(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    replacePorterItem(body: ReplacePorterItemCommandArguments | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/PorterItems/ReplacePorterItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReplacePorterItem(_response);
        });
    }

    protected processReplacePorterItem(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPorterBudgetItemPrices(body: GetPorterBudgetItemPricesCommandArguments | undefined, cancelToken?: CancelToken | undefined): Promise<GetPorterBudgetItemPricesViewModel> {
        let url_ = this.baseUrl + "/api/PorterItems/GetPorterBudgetItemPrices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPorterBudgetItemPrices(_response);
        });
    }

    protected processGetPorterBudgetItemPrices(response: AxiosResponse): Promise<GetPorterBudgetItemPricesViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPorterBudgetItemPricesViewModel.fromJS(resultData200);
            return Promise.resolve<GetPorterBudgetItemPricesViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPorterBudgetItemPricesViewModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPrices(body: GetPricesQueryArgs | undefined, cancelToken?: CancelToken | undefined): Promise<GetPricesViewModel> {
        let url_ = this.baseUrl + "/api/Price/GetPrices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPrices(_response);
        });
    }

    protected processGetPrices(response: AxiosResponse): Promise<GetPricesViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPricesViewModel.fromJS(resultData200);
            return Promise.resolve<GetPricesViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPricesViewModel>(null as any);
    }

    /**
     * @param languageId (optional) 
     * @param productId (optional) 
     * @return Success
     */
    getProductVariantsById(languageId: string | undefined, productId: string | undefined, cancelToken?: CancelToken | undefined): Promise<ProductVariantsViewModel> {
        let url_ = this.baseUrl + "/api/Product/GetProductVariantsById?";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductVariantsById(_response);
        });
    }

    protected processGetProductVariantsById(response: AxiosResponse): Promise<ProductVariantsViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductVariantsViewModel.fromJS(resultData200);
            return Promise.resolve<ProductVariantsViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductVariantsViewModel>(null as any);
    }

    /**
     * @param languageId (optional) 
     * @param productId (optional) 
     * @return Success
     */
    getProductMatrixById(languageId: string | undefined, productId: string | undefined, cancelToken?: CancelToken | undefined): Promise<ProductMatrixViewModel> {
        let url_ = this.baseUrl + "/api/Product/GetProductMatrixById?";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductMatrixById(_response);
        });
    }

    protected processGetProductMatrixById(response: AxiosResponse): Promise<ProductMatrixViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductMatrixViewModel.fromJS(resultData200);
            return Promise.resolve<ProductMatrixViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductMatrixViewModel>(null as any);
    }

    /**
     * @param languageId (optional) 
     * @param productId (optional) 
     * @return Success
     */
    getProductSpecListById(languageId: string | undefined, productId: string | undefined, cancelToken?: CancelToken | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Product/GetProductSpecListById?";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductSpecListById(_response);
        });
    }

    protected processGetProductSpecListById(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @param linkId (optional) 
     * @param langId (optional) 
     * @return Success
     */
    getProductSpec(linkId: string | undefined, langId: string | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Product/GetProductSpec?";
        if (linkId === null)
            throw new Error("The parameter 'linkId' cannot be null.");
        else if (linkId !== undefined)
            url_ += "linkId=" + encodeURIComponent("" + linkId) + "&";
        if (langId === null)
            throw new Error("The parameter 'langId' cannot be null.");
        else if (langId !== undefined)
            url_ += "langId=" + encodeURIComponent("" + langId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductSpec(_response);
        });
    }

    protected processGetProductSpec(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param languageId (optional) 
     * @param productId (optional) 
     * @return Success
     */
    getVariantCount(languageId: string | undefined, productId: string | undefined, cancelToken?: CancelToken | undefined): Promise<ProductViewModel[]> {
        let url_ = this.baseUrl + "/api/Product/GetVariantCount?";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVariantCount(_response);
        });
    }

    protected processGetVariantCount(response: AxiosResponse): Promise<ProductViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProductViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductViewModel[]>(null as any);
    }

    /**
     * @param shipmentNumber (optional) 
     * @param languageCode (optional) 
     * @return Success
     */
    getShipments(shipmentNumber: string | undefined, languageCode: string | undefined, cancelToken?: CancelToken | undefined): Promise<Shipment[]> {
        let url_ = this.baseUrl + "/api/Shipments/GetShipments?";
        if (shipmentNumber === null)
            throw new Error("The parameter 'shipmentNumber' cannot be null.");
        else if (shipmentNumber !== undefined)
            url_ += "shipmentNumber=" + encodeURIComponent("" + shipmentNumber) + "&";
        if (languageCode === null)
            throw new Error("The parameter 'languageCode' cannot be null.");
        else if (languageCode !== undefined)
            url_ += "languageCode=" + encodeURIComponent("" + languageCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShipments(_response);
        });
    }

    protected processGetShipments(response: AxiosResponse): Promise<Shipment[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Shipment.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Shipment[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Shipment[]>(null as any);
    }

    /**
     * @param shipmentNumber (optional) 
     * @return Success
     */
    getShipmentLines(shipmentNumber: string | undefined, cancelToken?: CancelToken | undefined): Promise<ShipmentLine[]> {
        let url_ = this.baseUrl + "/api/Shipments/GetShipmentLines?";
        if (shipmentNumber === null)
            throw new Error("The parameter 'shipmentNumber' cannot be null.");
        else if (shipmentNumber !== undefined)
            url_ += "shipmentNumber=" + encodeURIComponent("" + shipmentNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShipmentLines(_response);
        });
    }

    protected processGetShipmentLines(response: AxiosResponse): Promise<ShipmentLine[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShipmentLine.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ShipmentLine[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShipmentLine[]>(null as any);
    }
}

export class ScannedBarcode implements IScannedBarcode {
    state?: ScannedBarcodeState;
    number?: string;
    customerNo?: string;
    itemNo?: string;
    isValid?: boolean;
    errorMsg?: string;

    constructor(data?: IScannedBarcode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.number = _data["number"];
            this.customerNo = _data["customerNo"];
            this.itemNo = _data["itemNo"];
            this.isValid = _data["isValid"];
            this.errorMsg = _data["errorMsg"];
        }
    }

    static fromJS(data: any): ScannedBarcode {
        data = typeof data === 'object' ? data : {};
        let result = new ScannedBarcode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["number"] = this.number;
        data["customerNo"] = this.customerNo;
        data["itemNo"] = this.itemNo;
        data["isValid"] = this.isValid;
        data["errorMsg"] = this.errorMsg;
        return data;
    }
}

export interface IScannedBarcode {
    state?: ScannedBarcodeState;
    number?: string;
    customerNo?: string;
    itemNo?: string;
    isValid?: boolean;
    errorMsg?: string;
}

export class UpdateBarcodeListCommandArguments implements IUpdateBarcodeListCommandArguments {
    scannedBarcodeList?: ScannedBarcode[];
    state?: UpdateBarcodeListCommandArgumentsState;

    constructor(data?: IUpdateBarcodeListCommandArguments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["scannedBarcodeList"])) {
                this.scannedBarcodeList = [] as any;
                for (let item of _data["scannedBarcodeList"])
                    this.scannedBarcodeList!.push(ScannedBarcode.fromJS(item));
            }
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): UpdateBarcodeListCommandArguments {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBarcodeListCommandArguments();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.scannedBarcodeList)) {
            data["scannedBarcodeList"] = [];
            for (let item of this.scannedBarcodeList)
                data["scannedBarcodeList"].push(item.toJSON());
        }
        data["state"] = this.state;
        return data;
    }
}

export interface IUpdateBarcodeListCommandArguments {
    scannedBarcodeList?: ScannedBarcode[];
    state?: UpdateBarcodeListCommandArgumentsState;
}

export class PorterViewModel implements IPorterViewModel {
    allowMutation?: boolean;
    nonDismissable?: boolean;
    allowRetire?: boolean;
    id?: string;
    key?: string;
    customerNumber?: string;
    contactNo?: string;
    hasBudget?: boolean;
    showBudgetPoints?: boolean;
    showBudgetPrice?: boolean;
    firstName?: string;
    lastName?: string;
    email?: string;
    functionCode?: string;
    street?: string;
    city?: string;
    phone?: string;
    zip?: string;
    mutationCode?: string;
    sellToCustomerNumber?: string;
    sellToCustomerName?: string;
    readonly genericFields?: { [key: string]: any; };

    constructor(data?: IPorterViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowMutation = _data["allowMutation"];
            this.nonDismissable = _data["nonDismissable"];
            this.allowRetire = _data["allowRetire"];
            this.id = _data["id"];
            this.key = _data["key"];
            this.customerNumber = _data["customerNumber"];
            this.contactNo = _data["contactNo"];
            this.hasBudget = _data["hasBudget"];
            this.showBudgetPoints = _data["showBudgetPoints"];
            this.showBudgetPrice = _data["showBudgetPrice"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.functionCode = _data["functionCode"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.phone = _data["phone"];
            this.zip = _data["zip"];
            this.mutationCode = _data["mutationCode"];
            this.sellToCustomerNumber = _data["sellToCustomerNumber"];
            this.sellToCustomerName = _data["sellToCustomerName"];
            if (_data["genericFields"]) {
                (<any>this).genericFields = {} as any;
                for (let key in _data["genericFields"]) {
                    if (_data["genericFields"].hasOwnProperty(key))
                        (<any>(<any>this).genericFields)![key] = _data["genericFields"][key];
                }
            }
        }
    }

    static fromJS(data: any): PorterViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PorterViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowMutation"] = this.allowMutation;
        data["nonDismissable"] = this.nonDismissable;
        data["allowRetire"] = this.allowRetire;
        data["id"] = this.id;
        data["key"] = this.key;
        data["customerNumber"] = this.customerNumber;
        data["contactNo"] = this.contactNo;
        data["hasBudget"] = this.hasBudget;
        data["showBudgetPoints"] = this.showBudgetPoints;
        data["showBudgetPrice"] = this.showBudgetPrice;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["functionCode"] = this.functionCode;
        data["street"] = this.street;
        data["city"] = this.city;
        data["phone"] = this.phone;
        data["zip"] = this.zip;
        data["mutationCode"] = this.mutationCode;
        data["sellToCustomerNumber"] = this.sellToCustomerNumber;
        data["sellToCustomerName"] = this.sellToCustomerName;
        if (this.genericFields) {
            data["genericFields"] = {};
            for (let key in this.genericFields) {
                if (this.genericFields.hasOwnProperty(key))
                    (<any>data["genericFields"])[key] = (<any>this.genericFields)[key];
            }
        }
        return data;
    }
}

export interface IPorterViewModel {
    allowMutation?: boolean;
    nonDismissable?: boolean;
    allowRetire?: boolean;
    id?: string;
    key?: string;
    customerNumber?: string;
    contactNo?: string;
    hasBudget?: boolean;
    showBudgetPoints?: boolean;
    showBudgetPrice?: boolean;
    firstName?: string;
    lastName?: string;
    email?: string;
    functionCode?: string;
    street?: string;
    city?: string;
    phone?: string;
    zip?: string;
    mutationCode?: string;
    sellToCustomerNumber?: string;
    sellToCustomerName?: string;
    genericFields?: { [key: string]: any; };
}

export class ProductViewModel implements IProductViewModel {
    itemNumber?: string;
    productId?: string;
    productName?: string;
    productVariantId?: string;
    isOldModelSales?: boolean;
    imageName?: string;
    basicMetrics?: { [key: string]: any; };
    size?: string;
    subSize?: string;
    sortingOrder?: number;
    readonly isSubSize?: boolean;

    constructor(data?: IProductViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemNumber = _data["itemNumber"];
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.productVariantId = _data["productVariantId"];
            this.isOldModelSales = _data["isOldModelSales"];
            this.imageName = _data["imageName"];
            if (_data["basicMetrics"]) {
                this.basicMetrics = {} as any;
                for (let key in _data["basicMetrics"]) {
                    if (_data["basicMetrics"].hasOwnProperty(key))
                        (<any>this.basicMetrics)![key] = _data["basicMetrics"][key];
                }
            }
            this.size = _data["size"];
            this.subSize = _data["subSize"];
            this.sortingOrder = _data["sortingOrder"];
            (<any>this).isSubSize = _data["isSubSize"];
        }
    }

    static fromJS(data: any): ProductViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemNumber"] = this.itemNumber;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["productVariantId"] = this.productVariantId;
        data["isOldModelSales"] = this.isOldModelSales;
        data["imageName"] = this.imageName;
        if (this.basicMetrics) {
            data["basicMetrics"] = {};
            for (let key in this.basicMetrics) {
                if (this.basicMetrics.hasOwnProperty(key))
                    (<any>data["basicMetrics"])[key] = (<any>this.basicMetrics)[key];
            }
        }
        data["size"] = this.size;
        data["subSize"] = this.subSize;
        data["sortingOrder"] = this.sortingOrder;
        data["isSubSize"] = this.isSubSize;
        return data;
    }
}

export interface IProductViewModel {
    itemNumber?: string;
    productId?: string;
    productName?: string;
    productVariantId?: string;
    isOldModelSales?: boolean;
    imageName?: string;
    basicMetrics?: { [key: string]: any; };
    size?: string;
    subSize?: string;
    sortingOrder?: number;
    isSubSize?: boolean;
}

export class ProductVariantsViewModel implements IProductVariantsViewModel {
    productVariants?: ProductViewModel[];

    constructor(data?: IProductVariantsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["productVariants"])) {
                this.productVariants = [] as any;
                for (let item of _data["productVariants"])
                    this.productVariants!.push(ProductViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductVariantsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductVariantsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productVariants)) {
            data["productVariants"] = [];
            for (let item of this.productVariants)
                data["productVariants"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProductVariantsViewModel {
    productVariants?: ProductViewModel[];
}

export class ScannedBarcodeDetailsViewModel implements IScannedBarcodeDetailsViewModel {
    porterContactNumber?: string;
    itemNo?: string;
    sellToNumber?: string;
    sellToDescription?: string;
    imageUrl?: string;
    isValid?: boolean;
    porter?: PorterViewModel;
    fromPorter?: PorterViewModel;
    product?: ProductVariantsViewModel;

    constructor(data?: IScannedBarcodeDetailsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.porterContactNumber = _data["porterContactNumber"];
            this.itemNo = _data["itemNo"];
            this.sellToNumber = _data["sellToNumber"];
            this.sellToDescription = _data["sellToDescription"];
            this.imageUrl = _data["imageUrl"];
            this.isValid = _data["isValid"];
            this.porter = _data["porter"] ? PorterViewModel.fromJS(_data["porter"]) : <any>undefined;
            this.fromPorter = _data["fromPorter"] ? PorterViewModel.fromJS(_data["fromPorter"]) : <any>undefined;
            this.product = _data["product"] ? ProductVariantsViewModel.fromJS(_data["product"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ScannedBarcodeDetailsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScannedBarcodeDetailsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["porterContactNumber"] = this.porterContactNumber;
        data["itemNo"] = this.itemNo;
        data["sellToNumber"] = this.sellToNumber;
        data["sellToDescription"] = this.sellToDescription;
        data["imageUrl"] = this.imageUrl;
        data["isValid"] = this.isValid;
        data["porter"] = this.porter ? this.porter.toJSON() : <any>undefined;
        data["fromPorter"] = this.fromPorter ? this.fromPorter.toJSON() : <any>undefined;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        return data;
    }
}

export interface IScannedBarcodeDetailsViewModel {
    porterContactNumber?: string;
    itemNo?: string;
    sellToNumber?: string;
    sellToDescription?: string;
    imageUrl?: string;
    isValid?: boolean;
    porter?: PorterViewModel;
    fromPorter?: PorterViewModel;
    product?: ProductVariantsViewModel;
}

export class ConfirmItemReceivedViewModel implements IConfirmItemReceivedViewModel {
    item?: ScannedBarcode;
    details?: ScannedBarcodeDetailsViewModel;

    constructor(data?: IConfirmItemReceivedViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item = _data["item"] ? ScannedBarcode.fromJS(_data["item"]) : <any>undefined;
            this.details = _data["details"] ? ScannedBarcodeDetailsViewModel.fromJS(_data["details"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ConfirmItemReceivedViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmItemReceivedViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        data["details"] = this.details ? this.details.toJSON() : <any>undefined;
        return data;
    }
}

export interface IConfirmItemReceivedViewModel {
    item?: ScannedBarcode;
    details?: ScannedBarcodeDetailsViewModel;
}

export class ConfirmItemsReceivedCommandResponse implements IConfirmItemsReceivedCommandResponse {
    isValid?: boolean;
    list?: ConfirmItemReceivedViewModel[];

    constructor(data?: IConfirmItemsReceivedCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValid = _data["isValid"];
            if (Array.isArray(_data["list"])) {
                this.list = [] as any;
                for (let item of _data["list"])
                    this.list!.push(ConfirmItemReceivedViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConfirmItemsReceivedCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmItemsReceivedCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid;
        if (Array.isArray(this.list)) {
            data["list"] = [];
            for (let item of this.list)
                data["list"].push(item.toJSON());
        }
        return data;
    }
}

export interface IConfirmItemsReceivedCommandResponse {
    isValid?: boolean;
    list?: ConfirmItemReceivedViewModel[];
}

export class TakeItemOutOfCirculationViewModel implements ITakeItemOutOfCirculationViewModel {
    item?: ScannedBarcode;
    details?: ScannedBarcodeDetailsViewModel;

    constructor(data?: ITakeItemOutOfCirculationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item = _data["item"] ? ScannedBarcode.fromJS(_data["item"]) : <any>undefined;
            this.details = _data["details"] ? ScannedBarcodeDetailsViewModel.fromJS(_data["details"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TakeItemOutOfCirculationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TakeItemOutOfCirculationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        data["details"] = this.details ? this.details.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITakeItemOutOfCirculationViewModel {
    item?: ScannedBarcode;
    details?: ScannedBarcodeDetailsViewModel;
}

export class TakeItemOutOfCirculationCommandResponse implements ITakeItemOutOfCirculationCommandResponse {
    list?: TakeItemOutOfCirculationViewModel[];
    isValid?: boolean;

    constructor(data?: ITakeItemOutOfCirculationCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["list"])) {
                this.list = [] as any;
                for (let item of _data["list"])
                    this.list!.push(TakeItemOutOfCirculationViewModel.fromJS(item));
            }
            this.isValid = _data["isValid"];
        }
    }

    static fromJS(data: any): TakeItemOutOfCirculationCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TakeItemOutOfCirculationCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.list)) {
            data["list"] = [];
            for (let item of this.list)
                data["list"].push(item.toJSON());
        }
        data["isValid"] = this.isValid;
        return data;
    }
}

export interface ITakeItemOutOfCirculationCommandResponse {
    list?: TakeItemOutOfCirculationViewModel[];
    isValid?: boolean;
}

export class ChangePorterByBarcodeCommandArguments implements IChangePorterByBarcodeCommandArguments {
    fromPorter?: string;
    toPorter?: string;
    barcode?: ScannedBarcode;
    state?: ChangePorterByBarcodeCommandArgumentsState;

    constructor(data?: IChangePorterByBarcodeCommandArguments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromPorter = _data["fromPorter"];
            this.toPorter = _data["toPorter"];
            this.barcode = _data["barcode"] ? ScannedBarcode.fromJS(_data["barcode"]) : <any>undefined;
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): ChangePorterByBarcodeCommandArguments {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePorterByBarcodeCommandArguments();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromPorter"] = this.fromPorter;
        data["toPorter"] = this.toPorter;
        data["barcode"] = this.barcode ? this.barcode.toJSON() : <any>undefined;
        data["state"] = this.state;
        return data;
    }
}

export interface IChangePorterByBarcodeCommandArguments {
    fromPorter?: string;
    toPorter?: string;
    barcode?: ScannedBarcode;
    state?: ChangePorterByBarcodeCommandArgumentsState;
}

export class ChangePorterByBarcodeViewModel implements IChangePorterByBarcodeViewModel {
    item?: ScannedBarcode;
    details?: ScannedBarcodeDetailsViewModel;

    constructor(data?: IChangePorterByBarcodeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item = _data["item"] ? ScannedBarcode.fromJS(_data["item"]) : <any>undefined;
            this.details = _data["details"] ? ScannedBarcodeDetailsViewModel.fromJS(_data["details"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ChangePorterByBarcodeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePorterByBarcodeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        data["details"] = this.details ? this.details.toJSON() : <any>undefined;
        return data;
    }
}

export interface IChangePorterByBarcodeViewModel {
    item?: ScannedBarcode;
    details?: ScannedBarcodeDetailsViewModel;
}

export class ChangePorterByBarcodeCommandResponse implements IChangePorterByBarcodeCommandResponse {
    list?: ChangePorterByBarcodeViewModel[];
    isValid?: boolean;

    constructor(data?: IChangePorterByBarcodeCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["list"])) {
                this.list = [] as any;
                for (let item of _data["list"])
                    this.list!.push(ChangePorterByBarcodeViewModel.fromJS(item));
            }
            this.isValid = _data["isValid"];
        }
    }

    static fromJS(data: any): ChangePorterByBarcodeCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePorterByBarcodeCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.list)) {
            data["list"] = [];
            for (let item of this.list)
                data["list"].push(item.toJSON());
        }
        data["isValid"] = this.isValid;
        return data;
    }
}

export interface IChangePorterByBarcodeCommandResponse {
    list?: ChangePorterByBarcodeViewModel[];
    isValid?: boolean;
}

export class DownloadBarcodeViewModel implements IDownloadBarcodeViewModel {
    item?: ScannedBarcode;
    details?: ScannedBarcodeDetailsViewModel;

    constructor(data?: IDownloadBarcodeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item = _data["item"] ? ScannedBarcode.fromJS(_data["item"]) : <any>undefined;
            this.details = _data["details"] ? ScannedBarcodeDetailsViewModel.fromJS(_data["details"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DownloadBarcodeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadBarcodeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        data["details"] = this.details ? this.details.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDownloadBarcodeViewModel {
    item?: ScannedBarcode;
    details?: ScannedBarcodeDetailsViewModel;
}

export class DownloadBarcodeListRequestArguments implements IDownloadBarcodeListRequestArguments {
    list?: DownloadBarcodeViewModel[];

    constructor(data?: IDownloadBarcodeListRequestArguments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["list"])) {
                this.list = [] as any;
                for (let item of _data["list"])
                    this.list!.push(DownloadBarcodeViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownloadBarcodeListRequestArguments {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadBarcodeListRequestArguments();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.list)) {
            data["list"] = [];
            for (let item of this.list)
                data["list"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDownloadBarcodeListRequestArguments {
    list?: DownloadBarcodeViewModel[];
}

export class DownloadBarcodeListResponse implements IDownloadBarcodeListResponse {
    title?: string;
    content?: string;
    json?: any;

    constructor(data?: IDownloadBarcodeListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.content = _data["content"];
            this.json = _data["json"];
        }
    }

    static fromJS(data: any): DownloadBarcodeListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadBarcodeListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["content"] = this.content;
        data["json"] = this.json;
        return data;
    }
}

export interface IDownloadBarcodeListResponse {
    title?: string;
    content?: string;
    json?: any;
}

export class CreditMemo implements ICreditMemo {
    readonly creditMemoNumber?: string;
    readonly dueDate?: Date;
    readonly paid?: boolean;
    readonly amount?: number;
    readonly amountWithVat?: number;
    readonly locationName?: string;
    readonly billToName?: string;
    readonly billToAddress?: string;
    readonly billToAddress2?: string;
    readonly billToPostCode?: string;
    readonly billToCity?: string;
    readonly shipToName?: string;
    readonly shipToAddress?: string;
    readonly shipToAddress2?: string;
    readonly shipToPostCode?: string;
    readonly shipToCity?: string;

    constructor(data?: ICreditMemo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).creditMemoNumber = _data["creditMemoNumber"];
            (<any>this).dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            (<any>this).paid = _data["paid"];
            (<any>this).amount = _data["amount"];
            (<any>this).amountWithVat = _data["amountWithVat"];
            (<any>this).locationName = _data["locationName"];
            (<any>this).billToName = _data["billToName"];
            (<any>this).billToAddress = _data["billToAddress"];
            (<any>this).billToAddress2 = _data["billToAddress2"];
            (<any>this).billToPostCode = _data["billToPostCode"];
            (<any>this).billToCity = _data["billToCity"];
            (<any>this).shipToName = _data["shipToName"];
            (<any>this).shipToAddress = _data["shipToAddress"];
            (<any>this).shipToAddress2 = _data["shipToAddress2"];
            (<any>this).shipToPostCode = _data["shipToPostCode"];
            (<any>this).shipToCity = _data["shipToCity"];
        }
    }

    static fromJS(data: any): CreditMemo {
        data = typeof data === 'object' ? data : {};
        let result = new CreditMemo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creditMemoNumber"] = this.creditMemoNumber;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["paid"] = this.paid;
        data["amount"] = this.amount;
        data["amountWithVat"] = this.amountWithVat;
        data["locationName"] = this.locationName;
        data["billToName"] = this.billToName;
        data["billToAddress"] = this.billToAddress;
        data["billToAddress2"] = this.billToAddress2;
        data["billToPostCode"] = this.billToPostCode;
        data["billToCity"] = this.billToCity;
        data["shipToName"] = this.shipToName;
        data["shipToAddress"] = this.shipToAddress;
        data["shipToAddress2"] = this.shipToAddress2;
        data["shipToPostCode"] = this.shipToPostCode;
        data["shipToCity"] = this.shipToCity;
        return data;
    }
}

export interface ICreditMemo {
    creditMemoNumber?: string;
    dueDate?: Date;
    paid?: boolean;
    amount?: number;
    amountWithVat?: number;
    locationName?: string;
    billToName?: string;
    billToAddress?: string;
    billToAddress2?: string;
    billToPostCode?: string;
    billToCity?: string;
    shipToName?: string;
    shipToAddress?: string;
    shipToAddress2?: string;
    shipToPostCode?: string;
    shipToCity?: string;
}

export class CreditMemoLine implements ICreditMemoLine {
    readonly creditMemoLineNumber?: string;
    readonly description?: string;
    readonly productNumber?: string;
    readonly unitAmount?: number;
    readonly amount?: number;
    readonly amountWithVAT?: number;
    readonly unit?: string;
    readonly quantity?: number;
    readonly porterNumber?: string;

    constructor(data?: ICreditMemoLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).creditMemoLineNumber = _data["creditMemoLineNumber"];
            (<any>this).description = _data["description"];
            (<any>this).productNumber = _data["productNumber"];
            (<any>this).unitAmount = _data["unitAmount"];
            (<any>this).amount = _data["amount"];
            (<any>this).amountWithVAT = _data["amountWithVAT"];
            (<any>this).unit = _data["unit"];
            (<any>this).quantity = _data["quantity"];
            (<any>this).porterNumber = _data["porterNumber"];
        }
    }

    static fromJS(data: any): CreditMemoLine {
        data = typeof data === 'object' ? data : {};
        let result = new CreditMemoLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creditMemoLineNumber"] = this.creditMemoLineNumber;
        data["description"] = this.description;
        data["productNumber"] = this.productNumber;
        data["unitAmount"] = this.unitAmount;
        data["amount"] = this.amount;
        data["amountWithVAT"] = this.amountWithVAT;
        data["unit"] = this.unit;
        data["quantity"] = this.quantity;
        data["porterNumber"] = this.porterNumber;
        return data;
    }
}

export interface ICreditMemoLine {
    creditMemoLineNumber?: string;
    description?: string;
    productNumber?: string;
    unitAmount?: number;
    amount?: number;
    amountWithVAT?: number;
    unit?: string;
    quantity?: number;
    porterNumber?: string;
}

export class MutationLocation implements IMutationLocation {
    locationName?: string;
    customerNo?: string;
    mutationCode?: string;
    mutationDescription?: string;

    constructor(data?: IMutationLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationName = _data["locationName"];
            this.customerNo = _data["customerNo"];
            this.mutationCode = _data["mutationCode"];
            this.mutationDescription = _data["mutationDescription"];
        }
    }

    static fromJS(data: any): MutationLocation {
        data = typeof data === 'object' ? data : {};
        let result = new MutationLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationName"] = this.locationName;
        data["customerNo"] = this.customerNo;
        data["mutationCode"] = this.mutationCode;
        data["mutationDescription"] = this.mutationDescription;
        return data;
    }
}

export interface IMutationLocation {
    locationName?: string;
    customerNo?: string;
    mutationCode?: string;
    mutationDescription?: string;
}

export class CustomerByEmail implements ICustomerByEmail {
    userName?: string;
    name?: string;
    email?: string;

    constructor(data?: ICustomerByEmail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): CustomerByEmail {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerByEmail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["email"] = this.email;
        return data;
    }
}

export interface ICustomerByEmail {
    userName?: string;
    name?: string;
    email?: string;
}

export class GetCustomersByEmailViewModel implements IGetCustomersByEmailViewModel {
    customers?: CustomerByEmail[];

    constructor(data?: IGetCustomersByEmailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["customers"])) {
                this.customers = [] as any;
                for (let item of _data["customers"])
                    this.customers!.push(CustomerByEmail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCustomersByEmailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomersByEmailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.customers)) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCustomersByEmailViewModel {
    customers?: CustomerByEmail[];
}

export class CustomerBarcodeStatusCode implements ICustomerBarcodeStatusCode {
    description?: string;
    status?: string;

    constructor(data?: ICustomerBarcodeStatusCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CustomerBarcodeStatusCode {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerBarcodeStatusCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["status"] = this.status;
        return data;
    }
}

export interface ICustomerBarcodeStatusCode {
    description?: string;
    status?: string;
}

export class UpdateUserInfoRequestArgs implements IUpdateUserInfoRequestArgs {
    readonly name?: string;
    readonly email?: string;
    readonly phone?: string;

    constructor(data?: IUpdateUserInfoRequestArgs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            (<any>this).email = _data["email"];
            (<any>this).phone = _data["phone"];
        }
    }

    static fromJS(data: any): UpdateUserInfoRequestArgs {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserInfoRequestArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["phone"] = this.phone;
        return data;
    }
}

export interface IUpdateUserInfoRequestArgs {
    name?: string;
    email?: string;
    phone?: string;
}

export class ICurrencyKey implements IICurrencyKey {
    readonly code?: string;
    readonly extraInfo?: { [key: string]: any; };

    constructor(data?: IICurrencyKey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).code = _data["code"];
            if (_data["extraInfo"]) {
                (<any>this).extraInfo = {} as any;
                for (let key in _data["extraInfo"]) {
                    if (_data["extraInfo"].hasOwnProperty(key))
                        (<any>(<any>this).extraInfo)![key] = _data["extraInfo"][key];
                }
            }
        }
    }

    static fromJS(data: any): ICurrencyKey {
        data = typeof data === 'object' ? data : {};
        let result = new ICurrencyKey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.extraInfo) {
            data["extraInfo"] = {};
            for (let key in this.extraInfo) {
                if (this.extraInfo.hasOwnProperty(key))
                    (<any>data["extraInfo"])[key] = (<any>this.extraInfo)[key];
            }
        }
        return data;
    }
}

export interface IICurrencyKey {
    code?: string;
    extraInfo?: { [key: string]: any; };
}

export class IPrice implements IIPrice {
    currencyKey?: ICurrencyKey;
    readonly priceWithoutVat?: number;
    readonly priceWithVat?: number;
    readonly vat?: number;
    readonly vatPercentage?: number;

    constructor(data?: IIPrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currencyKey = _data["currencyKey"] ? ICurrencyKey.fromJS(_data["currencyKey"]) : <any>undefined;
            (<any>this).priceWithoutVat = _data["priceWithoutVat"];
            (<any>this).priceWithVat = _data["priceWithVat"];
            (<any>this).vat = _data["vat"];
            (<any>this).vatPercentage = _data["vatPercentage"];
        }
    }

    static fromJS(data: any): IPrice {
        data = typeof data === 'object' ? data : {};
        let result = new IPrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencyKey"] = this.currencyKey ? this.currencyKey.toJSON() : <any>undefined;
        data["priceWithoutVat"] = this.priceWithoutVat;
        data["priceWithVat"] = this.priceWithVat;
        data["vat"] = this.vat;
        data["vatPercentage"] = this.vatPercentage;
        return data;
    }
}

export interface IIPrice {
    currencyKey?: ICurrencyKey;
    priceWithoutVat?: number;
    priceWithVat?: number;
    vat?: number;
    vatPercentage?: number;
}

export class IShippingMethod implements IIShippingMethod {
    readonly internalId?: string;
    readonly name?: string;
    readonly countryCode?: string;
    shippingFee?: IPrice;
    readonly trackAndTrace?: string;
    readonly extraInfo?: { [key: string]: any; };

    constructor(data?: IIShippingMethod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).internalId = _data["internalId"];
            (<any>this).name = _data["name"];
            (<any>this).countryCode = _data["countryCode"];
            this.shippingFee = _data["shippingFee"] ? IPrice.fromJS(_data["shippingFee"]) : <any>undefined;
            (<any>this).trackAndTrace = _data["trackAndTrace"];
            if (_data["extraInfo"]) {
                (<any>this).extraInfo = {} as any;
                for (let key in _data["extraInfo"]) {
                    if (_data["extraInfo"].hasOwnProperty(key))
                        (<any>(<any>this).extraInfo)![key] = _data["extraInfo"][key];
                }
            }
        }
    }

    static fromJS(data: any): IShippingMethod {
        data = typeof data === 'object' ? data : {};
        let result = new IShippingMethod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["internalId"] = this.internalId;
        data["name"] = this.name;
        data["countryCode"] = this.countryCode;
        data["shippingFee"] = this.shippingFee ? this.shippingFee.toJSON() : <any>undefined;
        data["trackAndTrace"] = this.trackAndTrace;
        if (this.extraInfo) {
            data["extraInfo"] = {};
            for (let key in this.extraInfo) {
                if (this.extraInfo.hasOwnProperty(key))
                    (<any>data["extraInfo"])[key] = (<any>this.extraInfo)[key];
            }
        }
        return data;
    }
}

export interface IIShippingMethod {
    internalId?: string;
    name?: string;
    countryCode?: string;
    shippingFee?: IPrice;
    trackAndTrace?: string;
    extraInfo?: { [key: string]: any; };
}

export class IPaymentMethod implements IIPaymentMethod {
    readonly internalId?: string;
    readonly name?: string;
    fee?: IPrice;
    readonly gatewayUniqueId?: string;
    readonly extraInfo?: { [key: string]: any; };

    constructor(data?: IIPaymentMethod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).internalId = _data["internalId"];
            (<any>this).name = _data["name"];
            this.fee = _data["fee"] ? IPrice.fromJS(_data["fee"]) : <any>undefined;
            (<any>this).gatewayUniqueId = _data["gatewayUniqueId"];
            if (_data["extraInfo"]) {
                (<any>this).extraInfo = {} as any;
                for (let key in _data["extraInfo"]) {
                    if (_data["extraInfo"].hasOwnProperty(key))
                        (<any>(<any>this).extraInfo)![key] = _data["extraInfo"][key];
                }
            }
        }
    }

    static fromJS(data: any): IPaymentMethod {
        data = typeof data === 'object' ? data : {};
        let result = new IPaymentMethod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["internalId"] = this.internalId;
        data["name"] = this.name;
        data["fee"] = this.fee ? this.fee.toJSON() : <any>undefined;
        data["gatewayUniqueId"] = this.gatewayUniqueId;
        if (this.extraInfo) {
            data["extraInfo"] = {};
            for (let key in this.extraInfo) {
                if (this.extraInfo.hasOwnProperty(key))
                    (<any>data["extraInfo"])[key] = (<any>this.extraInfo)[key];
            }
        }
        return data;
    }
}

export interface IIPaymentMethod {
    internalId?: string;
    name?: string;
    fee?: IPrice;
    gatewayUniqueId?: string;
    extraInfo?: { [key: string]: any; };
}

export class IProductKey implements IIProductKey {
    readonly productId?: string;
    readonly variantId?: string;
    readonly unitOfMeasure?: string;

    constructor(data?: IIProductKey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).productId = _data["productId"];
            (<any>this).variantId = _data["variantId"];
            (<any>this).unitOfMeasure = _data["unitOfMeasure"];
        }
    }

    static fromJS(data: any): IProductKey {
        data = typeof data === 'object' ? data : {};
        let result = new IProductKey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["variantId"] = this.variantId;
        data["unitOfMeasure"] = this.unitOfMeasure;
        return data;
    }
}

export interface IIProductKey {
    productId?: string;
    variantId?: string;
    unitOfMeasure?: string;
}

export class IOrderLine implements IIOrderLine {
    type?: IOrderLineType;
    id?: string;
    parentId?: string;
    productKey?: IProductKey;
    quantity?: number;
    linePrice?: IPrice;
    netLinePrice?: IPrice;
    netUnitPrice?: IPrice;
    unitPrice?: IPrice;
    discountPercentage?: number;
    lineDiscount?: IPrice;
    description?: string;
    readonly extraInfo?: { [key: string]: any; };

    constructor(data?: IIOrderLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.id = _data["id"];
            this.parentId = _data["parentId"];
            this.productKey = _data["productKey"] ? IProductKey.fromJS(_data["productKey"]) : <any>undefined;
            this.quantity = _data["quantity"];
            this.linePrice = _data["linePrice"] ? IPrice.fromJS(_data["linePrice"]) : <any>undefined;
            this.netLinePrice = _data["netLinePrice"] ? IPrice.fromJS(_data["netLinePrice"]) : <any>undefined;
            this.netUnitPrice = _data["netUnitPrice"] ? IPrice.fromJS(_data["netUnitPrice"]) : <any>undefined;
            this.unitPrice = _data["unitPrice"] ? IPrice.fromJS(_data["unitPrice"]) : <any>undefined;
            this.discountPercentage = _data["discountPercentage"];
            this.lineDiscount = _data["lineDiscount"] ? IPrice.fromJS(_data["lineDiscount"]) : <any>undefined;
            this.description = _data["description"];
            if (_data["extraInfo"]) {
                (<any>this).extraInfo = {} as any;
                for (let key in _data["extraInfo"]) {
                    if (_data["extraInfo"].hasOwnProperty(key))
                        (<any>(<any>this).extraInfo)![key] = _data["extraInfo"][key];
                }
            }
        }
    }

    static fromJS(data: any): IOrderLine {
        data = typeof data === 'object' ? data : {};
        let result = new IOrderLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["id"] = this.id;
        data["parentId"] = this.parentId;
        data["productKey"] = this.productKey ? this.productKey.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        data["linePrice"] = this.linePrice ? this.linePrice.toJSON() : <any>undefined;
        data["netLinePrice"] = this.netLinePrice ? this.netLinePrice.toJSON() : <any>undefined;
        data["netUnitPrice"] = this.netUnitPrice ? this.netUnitPrice.toJSON() : <any>undefined;
        data["unitPrice"] = this.unitPrice ? this.unitPrice.toJSON() : <any>undefined;
        data["discountPercentage"] = this.discountPercentage;
        data["lineDiscount"] = this.lineDiscount ? this.lineDiscount.toJSON() : <any>undefined;
        data["description"] = this.description;
        if (this.extraInfo) {
            data["extraInfo"] = {};
            for (let key in this.extraInfo) {
                if (this.extraInfo.hasOwnProperty(key))
                    (<any>data["extraInfo"])[key] = (<any>this.extraInfo)[key];
            }
        }
        return data;
    }
}

export interface IIOrderLine {
    type?: IOrderLineType;
    id?: string;
    parentId?: string;
    productKey?: IProductKey;
    quantity?: number;
    linePrice?: IPrice;
    netLinePrice?: IPrice;
    netUnitPrice?: IPrice;
    unitPrice?: IPrice;
    discountPercentage?: number;
    lineDiscount?: IPrice;
    description?: string;
    extraInfo?: { [key: string]: any; };
}

export class IAddress implements IIAddress {
    readonly customerNumber?: string;
    company?: string;
    email?: string;
    phone?: string;
    name?: string;
    address1?: string;
    address2?: string;
    zip?: string;
    city?: string;
    country?: string;
    readonly extraInfo?: { [key: string]: any; };

    constructor(data?: IIAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).customerNumber = _data["customerNumber"];
            this.company = _data["company"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.name = _data["name"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.zip = _data["zip"];
            this.city = _data["city"];
            this.country = _data["country"];
            if (_data["extraInfo"]) {
                (<any>this).extraInfo = {} as any;
                for (let key in _data["extraInfo"]) {
                    if (_data["extraInfo"].hasOwnProperty(key))
                        (<any>(<any>this).extraInfo)![key] = _data["extraInfo"][key];
                }
            }
        }
    }

    static fromJS(data: any): IAddress {
        data = typeof data === 'object' ? data : {};
        let result = new IAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerNumber"] = this.customerNumber;
        data["company"] = this.company;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["name"] = this.name;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["zip"] = this.zip;
        data["city"] = this.city;
        data["country"] = this.country;
        if (this.extraInfo) {
            data["extraInfo"] = {};
            for (let key in this.extraInfo) {
                if (this.extraInfo.hasOwnProperty(key))
                    (<any>data["extraInfo"])[key] = (<any>this.extraInfo)[key];
            }
        }
        return data;
    }
}

export interface IIAddress {
    customerNumber?: string;
    company?: string;
    email?: string;
    phone?: string;
    name?: string;
    address1?: string;
    address2?: string;
    zip?: string;
    city?: string;
    country?: string;
    extraInfo?: { [key: string]: any; };
}

export class ITransactionInfo implements IITransactionInfo {
    value?: string;
    type?: string;
    status?: string;
    number?: string;
    amount?: number;
    payGatewayCode?: string;
    cardType?: string;
    cardNumber?: string;
    readonly extraInfo?: { [key: string]: any; };

    constructor(data?: IITransactionInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.number = _data["number"];
            this.amount = _data["amount"];
            this.payGatewayCode = _data["payGatewayCode"];
            this.cardType = _data["cardType"];
            this.cardNumber = _data["cardNumber"];
            if (_data["extraInfo"]) {
                (<any>this).extraInfo = {} as any;
                for (let key in _data["extraInfo"]) {
                    if (_data["extraInfo"].hasOwnProperty(key))
                        (<any>(<any>this).extraInfo)![key] = _data["extraInfo"][key];
                }
            }
        }
    }

    static fromJS(data: any): ITransactionInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ITransactionInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["type"] = this.type;
        data["status"] = this.status;
        data["number"] = this.number;
        data["amount"] = this.amount;
        data["payGatewayCode"] = this.payGatewayCode;
        data["cardType"] = this.cardType;
        data["cardNumber"] = this.cardNumber;
        if (this.extraInfo) {
            data["extraInfo"] = {};
            for (let key in this.extraInfo) {
                if (this.extraInfo.hasOwnProperty(key))
                    (<any>data["extraInfo"])[key] = (<any>this.extraInfo)[key];
            }
        }
        return data;
    }
}

export interface IITransactionInfo {
    value?: string;
    type?: string;
    status?: string;
    number?: string;
    amount?: number;
    payGatewayCode?: string;
    cardType?: string;
    cardNumber?: string;
    extraInfo?: { [key: string]: any; };
}

export class IIdentification implements IIIdentification {
    readonly shopIdentifier?: string;
    readonly loginId?: string;
    readonly customerNumber?: string;
    readonly extraInfo?: { [key: string]: any; };

    constructor(data?: IIIdentification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).shopIdentifier = _data["shopIdentifier"];
            (<any>this).loginId = _data["loginId"];
            (<any>this).customerNumber = _data["customerNumber"];
            if (_data["extraInfo"]) {
                (<any>this).extraInfo = {} as any;
                for (let key in _data["extraInfo"]) {
                    if (_data["extraInfo"].hasOwnProperty(key))
                        (<any>(<any>this).extraInfo)![key] = _data["extraInfo"][key];
                }
            }
        }
    }

    static fromJS(data: any): IIdentification {
        data = typeof data === 'object' ? data : {};
        let result = new IIdentification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shopIdentifier"] = this.shopIdentifier;
        data["loginId"] = this.loginId;
        data["customerNumber"] = this.customerNumber;
        if (this.extraInfo) {
            data["extraInfo"] = {};
            for (let key in this.extraInfo) {
                if (this.extraInfo.hasOwnProperty(key))
                    (<any>data["extraInfo"])[key] = (<any>this.extraInfo)[key];
            }
        }
        return data;
    }
}

export interface IIIdentification {
    shopIdentifier?: string;
    loginId?: string;
    customerNumber?: string;
    extraInfo?: { [key: string]: any; };
}

export class IPostedOrder implements IIPostedOrder {
    postingDate?: Date;
    shippingDate?: Date;
    deliveryDate?: Date;
    dueDate?: Date;
    reference?: string;
    comment?: string;
    orderDate?: Date;
    couponCode?: string;
    shippingMethod?: IShippingMethod;
    paymentMethod?: IPaymentMethod;
    orderLines?: IOrderLine[];
    totalPrice?: IPrice;
    discount?: IPrice;
    totalNetPrice?: IPrice;
    shippingAddress?: IAddress;
    billingAddress?: IAddress;
    transactionInfo?: ITransactionInfo;
    identification?: IIdentification;
    orderId?: string;
    externalOrderId?: string;
    readonly extraInfo?: { [key: string]: any; };

    constructor(data?: IIPostedOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postingDate = _data["postingDate"] ? new Date(_data["postingDate"].toString()) : <any>undefined;
            this.shippingDate = _data["shippingDate"] ? new Date(_data["shippingDate"].toString()) : <any>undefined;
            this.deliveryDate = _data["deliveryDate"] ? new Date(_data["deliveryDate"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.reference = _data["reference"];
            this.comment = _data["comment"];
            this.orderDate = _data["orderDate"] ? new Date(_data["orderDate"].toString()) : <any>undefined;
            this.couponCode = _data["couponCode"];
            this.shippingMethod = _data["shippingMethod"] ? IShippingMethod.fromJS(_data["shippingMethod"]) : <any>undefined;
            this.paymentMethod = _data["paymentMethod"] ? IPaymentMethod.fromJS(_data["paymentMethod"]) : <any>undefined;
            if (Array.isArray(_data["orderLines"])) {
                this.orderLines = [] as any;
                for (let item of _data["orderLines"])
                    this.orderLines!.push(IOrderLine.fromJS(item));
            }
            this.totalPrice = _data["totalPrice"] ? IPrice.fromJS(_data["totalPrice"]) : <any>undefined;
            this.discount = _data["discount"] ? IPrice.fromJS(_data["discount"]) : <any>undefined;
            this.totalNetPrice = _data["totalNetPrice"] ? IPrice.fromJS(_data["totalNetPrice"]) : <any>undefined;
            this.shippingAddress = _data["shippingAddress"] ? IAddress.fromJS(_data["shippingAddress"]) : <any>undefined;
            this.billingAddress = _data["billingAddress"] ? IAddress.fromJS(_data["billingAddress"]) : <any>undefined;
            this.transactionInfo = _data["transactionInfo"] ? ITransactionInfo.fromJS(_data["transactionInfo"]) : <any>undefined;
            this.identification = _data["identification"] ? IIdentification.fromJS(_data["identification"]) : <any>undefined;
            this.orderId = _data["orderId"];
            this.externalOrderId = _data["externalOrderId"];
            if (_data["extraInfo"]) {
                (<any>this).extraInfo = {} as any;
                for (let key in _data["extraInfo"]) {
                    if (_data["extraInfo"].hasOwnProperty(key))
                        (<any>(<any>this).extraInfo)![key] = _data["extraInfo"][key];
                }
            }
        }
    }

    static fromJS(data: any): IPostedOrder {
        data = typeof data === 'object' ? data : {};
        let result = new IPostedOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postingDate"] = this.postingDate ? this.postingDate.toISOString() : <any>undefined;
        data["shippingDate"] = this.shippingDate ? this.shippingDate.toISOString() : <any>undefined;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["reference"] = this.reference;
        data["comment"] = this.comment;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
        data["couponCode"] = this.couponCode;
        data["shippingMethod"] = this.shippingMethod ? this.shippingMethod.toJSON() : <any>undefined;
        data["paymentMethod"] = this.paymentMethod ? this.paymentMethod.toJSON() : <any>undefined;
        if (Array.isArray(this.orderLines)) {
            data["orderLines"] = [];
            for (let item of this.orderLines)
                data["orderLines"].push(item.toJSON());
        }
        data["totalPrice"] = this.totalPrice ? this.totalPrice.toJSON() : <any>undefined;
        data["discount"] = this.discount ? this.discount.toJSON() : <any>undefined;
        data["totalNetPrice"] = this.totalNetPrice ? this.totalNetPrice.toJSON() : <any>undefined;
        data["shippingAddress"] = this.shippingAddress ? this.shippingAddress.toJSON() : <any>undefined;
        data["billingAddress"] = this.billingAddress ? this.billingAddress.toJSON() : <any>undefined;
        data["transactionInfo"] = this.transactionInfo ? this.transactionInfo.toJSON() : <any>undefined;
        data["identification"] = this.identification ? this.identification.toJSON() : <any>undefined;
        data["orderId"] = this.orderId;
        data["externalOrderId"] = this.externalOrderId;
        if (this.extraInfo) {
            data["extraInfo"] = {};
            for (let key in this.extraInfo) {
                if (this.extraInfo.hasOwnProperty(key))
                    (<any>data["extraInfo"])[key] = (<any>this.extraInfo)[key];
            }
        }
        return data;
    }
}

export interface IIPostedOrder {
    postingDate?: Date;
    shippingDate?: Date;
    deliveryDate?: Date;
    dueDate?: Date;
    reference?: string;
    comment?: string;
    orderDate?: Date;
    couponCode?: string;
    shippingMethod?: IShippingMethod;
    paymentMethod?: IPaymentMethod;
    orderLines?: IOrderLine[];
    totalPrice?: IPrice;
    discount?: IPrice;
    totalNetPrice?: IPrice;
    shippingAddress?: IAddress;
    billingAddress?: IAddress;
    transactionInfo?: ITransactionInfo;
    identification?: IIdentification;
    orderId?: string;
    externalOrderId?: string;
    extraInfo?: { [key: string]: any; };
}

export class Porter implements IPorter {
    customerNo?: string;
    contactNo?: string;
    firstName?: string;
    lastName?: string;
    street?: string;
    city?: string;
    phone?: string;
    zip?: string;
    hasBudget?: boolean;
    showBudgetPoints?: boolean;
    showBudgetPrice?: boolean;
    functionCode?: string;
    email?: string;
    nonDismissable?: boolean;
    readonly genericFields?: { [key: string]: any; };
    id?: string;

    constructor(data?: IPorter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerNo = _data["customerNo"];
            this.contactNo = _data["contactNo"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.phone = _data["phone"];
            this.zip = _data["zip"];
            this.hasBudget = _data["hasBudget"];
            this.showBudgetPoints = _data["showBudgetPoints"];
            this.showBudgetPrice = _data["showBudgetPrice"];
            this.functionCode = _data["functionCode"];
            this.email = _data["email"];
            this.nonDismissable = _data["nonDismissable"];
            if (_data["genericFields"]) {
                (<any>this).genericFields = {} as any;
                for (let key in _data["genericFields"]) {
                    if (_data["genericFields"].hasOwnProperty(key))
                        (<any>(<any>this).genericFields)![key] = _data["genericFields"][key];
                }
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Porter {
        data = typeof data === 'object' ? data : {};
        let result = new Porter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerNo"] = this.customerNo;
        data["contactNo"] = this.contactNo;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["street"] = this.street;
        data["city"] = this.city;
        data["phone"] = this.phone;
        data["zip"] = this.zip;
        data["hasBudget"] = this.hasBudget;
        data["showBudgetPoints"] = this.showBudgetPoints;
        data["showBudgetPrice"] = this.showBudgetPrice;
        data["functionCode"] = this.functionCode;
        data["email"] = this.email;
        data["nonDismissable"] = this.nonDismissable;
        if (this.genericFields) {
            data["genericFields"] = {};
            for (let key in this.genericFields) {
                if (this.genericFields.hasOwnProperty(key))
                    (<any>data["genericFields"])[key] = (<any>this.genericFields)[key];
            }
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IPorter {
    customerNo?: string;
    contactNo?: string;
    firstName?: string;
    lastName?: string;
    street?: string;
    city?: string;
    phone?: string;
    zip?: string;
    hasBudget?: boolean;
    showBudgetPoints?: boolean;
    showBudgetPrice?: boolean;
    functionCode?: string;
    email?: string;
    nonDismissable?: boolean;
    genericFields?: { [key: string]: any; };
    id?: string;
}

export class InvoiceViewModel implements IInvoiceViewModel {
    invoice?: IPostedOrder;
    readonly shipDate?: Date | undefined;
    readonly shipDateString?: string;
    readonly porters?: { [key: string]: Porter; };
    linkId?: string;
    status?: number;

    constructor(data?: IInvoiceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoice = _data["invoice"] ? IPostedOrder.fromJS(_data["invoice"]) : <any>undefined;
            (<any>this).shipDate = _data["shipDate"] ? new Date(_data["shipDate"].toString()) : <any>undefined;
            (<any>this).shipDateString = _data["shipDateString"];
            if (_data["porters"]) {
                (<any>this).porters = {} as any;
                for (let key in _data["porters"]) {
                    if (_data["porters"].hasOwnProperty(key))
                        (<any>(<any>this).porters)![key] = _data["porters"][key] ? Porter.fromJS(_data["porters"][key]) : new Porter();
                }
            }
            this.linkId = _data["linkId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): InvoiceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoice"] = this.invoice ? this.invoice.toJSON() : <any>undefined;
        data["shipDate"] = this.shipDate ? this.shipDate.toISOString() : <any>undefined;
        data["shipDateString"] = this.shipDateString;
        if (this.porters) {
            data["porters"] = {};
            for (let key in this.porters) {
                if (this.porters.hasOwnProperty(key))
                    (<any>data["porters"])[key] = this.porters[key] ? this.porters[key].toJSON() : <any>undefined;
            }
        }
        data["linkId"] = this.linkId;
        data["status"] = this.status;
        return data;
    }
}

export interface IInvoiceViewModel {
    invoice?: IPostedOrder;
    shipDate?: Date | undefined;
    shipDateString?: string;
    porters?: { [key: string]: Porter; };
    linkId?: string;
    status?: number;
}

export class GetInvoicesViewModel implements IGetInvoicesViewModel {
    readonly invoices?: InvoiceViewModel[];

    constructor(data?: IGetInvoicesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["invoices"])) {
                (<any>this).invoices = [] as any;
                for (let item of _data["invoices"])
                    (<any>this).invoices!.push(InvoiceViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetInvoicesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetInvoicesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetInvoicesViewModel {
    invoices?: InvoiceViewModel[];
}

export class GetRecentOrdersViewModel implements IGetRecentOrdersViewModel {
    readonly orders?: InvoiceViewModel[];

    constructor(data?: IGetRecentOrdersViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["orders"])) {
                (<any>this).orders = [] as any;
                for (let item of _data["orders"])
                    (<any>this).orders!.push(InvoiceViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRecentOrdersViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecentOrdersViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetRecentOrdersViewModel {
    orders?: InvoiceViewModel[];
}

export class GetInvoiceViewModel implements IGetInvoiceViewModel {
    invoice?: InvoiceViewModel;
    readonly canApprove?: boolean;

    constructor(data?: IGetInvoiceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoice = _data["invoice"] ? InvoiceViewModel.fromJS(_data["invoice"]) : <any>undefined;
            (<any>this).canApprove = _data["canApprove"];
        }
    }

    static fromJS(data: any): GetInvoiceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetInvoiceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoice"] = this.invoice ? this.invoice.toJSON() : <any>undefined;
        data["canApprove"] = this.canApprove;
        return data;
    }
}

export interface IGetInvoiceViewModel {
    invoice?: InvoiceViewModel;
    canApprove?: boolean;
}

export class NavError implements INavError {
    id?: number;
    customerNo?: string;
    errorSource?: string;
    errorMessage?: string;
    filters?: string;
    created?: Date;

    constructor(data?: INavError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerNo = _data["customerNo"];
            this.errorSource = _data["errorSource"];
            this.errorMessage = _data["errorMessage"];
            this.filters = _data["filters"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NavError {
        data = typeof data === 'object' ? data : {};
        let result = new NavError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerNo"] = this.customerNo;
        data["errorSource"] = this.errorSource;
        data["errorMessage"] = this.errorMessage;
        data["filters"] = this.filters;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface INavError {
    id?: number;
    customerNo?: string;
    errorSource?: string;
    errorMessage?: string;
    filters?: string;
    created?: Date;
}

export class PendingOrderViewModel implements IPendingOrderViewModel {
    postedOrder?: IPostedOrder;
    linkId?: string;
    status?: number;

    constructor(data?: IPendingOrderViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postedOrder = _data["postedOrder"] ? IPostedOrder.fromJS(_data["postedOrder"]) : <any>undefined;
            this.linkId = _data["linkId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): PendingOrderViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PendingOrderViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postedOrder"] = this.postedOrder ? this.postedOrder.toJSON() : <any>undefined;
        data["linkId"] = this.linkId;
        data["status"] = this.status;
        return data;
    }
}

export interface IPendingOrderViewModel {
    postedOrder?: IPostedOrder;
    linkId?: string;
    status?: number;
}

export class GetPendingOrdersViewModel implements IGetPendingOrdersViewModel {
    readonly orders?: PendingOrderViewModel[];
    readonly canApprove?: boolean;

    constructor(data?: IGetPendingOrdersViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["orders"])) {
                (<any>this).orders = [] as any;
                for (let item of _data["orders"])
                    (<any>this).orders!.push(PendingOrderViewModel.fromJS(item));
            }
            (<any>this).canApprove = _data["canApprove"];
        }
    }

    static fromJS(data: any): GetPendingOrdersViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetPendingOrdersViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        data["canApprove"] = this.canApprove;
        return data;
    }
}

export interface IGetPendingOrdersViewModel {
    orders?: PendingOrderViewModel[];
    canApprove?: boolean;
}

export class AcceptPendingOrderArgs implements IAcceptPendingOrderArgs {
    readonly linkId?: string;
    readonly orderId?: string;
    readonly email?: string;

    constructor(data?: IAcceptPendingOrderArgs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).linkId = _data["linkId"];
            (<any>this).orderId = _data["orderId"];
            (<any>this).email = _data["email"];
        }
    }

    static fromJS(data: any): AcceptPendingOrderArgs {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptPendingOrderArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linkId"] = this.linkId;
        data["orderId"] = this.orderId;
        data["email"] = this.email;
        return data;
    }
}

export interface IAcceptPendingOrderArgs {
    linkId?: string;
    orderId?: string;
    email?: string;
}

export class RejectPendingOrderArgs implements IRejectPendingOrderArgs {
    readonly linkId?: string;
    readonly orderId?: string;
    readonly email?: string;

    constructor(data?: IRejectPendingOrderArgs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).linkId = _data["linkId"];
            (<any>this).orderId = _data["orderId"];
            (<any>this).email = _data["email"];
        }
    }

    static fromJS(data: any): RejectPendingOrderArgs {
        data = typeof data === 'object' ? data : {};
        let result = new RejectPendingOrderArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linkId"] = this.linkId;
        data["orderId"] = this.orderId;
        data["email"] = this.email;
        return data;
    }
}

export interface IRejectPendingOrderArgs {
    linkId?: string;
    orderId?: string;
    email?: string;
}

export class RequestModifyPendingOrderArgs implements IRequestModifyPendingOrderArgs {
    readonly linkId?: string;
    readonly orderId?: string;
    readonly email?: string;
    readonly comment?: string;

    constructor(data?: IRequestModifyPendingOrderArgs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).linkId = _data["linkId"];
            (<any>this).orderId = _data["orderId"];
            (<any>this).email = _data["email"];
            (<any>this).comment = _data["comment"];
        }
    }

    static fromJS(data: any): RequestModifyPendingOrderArgs {
        data = typeof data === 'object' ? data : {};
        let result = new RequestModifyPendingOrderArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linkId"] = this.linkId;
        data["orderId"] = this.orderId;
        data["email"] = this.email;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IRequestModifyPendingOrderArgs {
    linkId?: string;
    orderId?: string;
    email?: string;
    comment?: string;
}

export class GenericFieldDescription implements IGenericFieldDescription {
    key?: string;
    readonly caption?: string;
    readonly inputType?: string;

    constructor(data?: IGenericFieldDescription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            (<any>this).caption = _data["caption"];
            (<any>this).inputType = _data["inputType"];
        }
    }

    static fromJS(data: any): GenericFieldDescription {
        data = typeof data === 'object' ? data : {};
        let result = new GenericFieldDescription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["caption"] = this.caption;
        data["inputType"] = this.inputType;
        return data;
    }
}

export interface IGenericFieldDescription {
    key?: string;
    caption?: string;
    inputType?: string;
}

export class PorterListViewModel implements IPorterListViewModel {
    readonly fields?: GenericFieldDescription[];
    readonly porters?: PorterViewModel[];
    readonly locations?: MutationLocation[];

    constructor(data?: IPorterListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fields"])) {
                (<any>this).fields = [] as any;
                for (let item of _data["fields"])
                    (<any>this).fields!.push(GenericFieldDescription.fromJS(item));
            }
            if (Array.isArray(_data["porters"])) {
                (<any>this).porters = [] as any;
                for (let item of _data["porters"])
                    (<any>this).porters!.push(PorterViewModel.fromJS(item));
            }
            if (Array.isArray(_data["locations"])) {
                (<any>this).locations = [] as any;
                for (let item of _data["locations"])
                    (<any>this).locations!.push(MutationLocation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PorterListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PorterListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        if (Array.isArray(this.porters)) {
            data["porters"] = [];
            for (let item of this.porters)
                data["porters"].push(item.toJSON());
        }
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPorterListViewModel {
    fields?: GenericFieldDescription[];
    porters?: PorterViewModel[];
    locations?: MutationLocation[];
}

export class PorterFieldListViewModel implements IPorterFieldListViewModel {
    readonly fields?: GenericFieldDescription[];

    constructor(data?: IPorterFieldListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fields"])) {
                (<any>this).fields = [] as any;
                for (let item of _data["fields"])
                    (<any>this).fields!.push(GenericFieldDescription.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PorterFieldListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PorterFieldListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPorterFieldListViewModel {
    fields?: GenericFieldDescription[];
}

export class GetPorterViewModel implements IGetPorterViewModel {
    readonly fields?: GenericFieldDescription[];
    porter?: PorterViewModel;

    constructor(data?: IGetPorterViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fields"])) {
                (<any>this).fields = [] as any;
                for (let item of _data["fields"])
                    (<any>this).fields!.push(GenericFieldDescription.fromJS(item));
            }
            this.porter = _data["porter"] ? PorterViewModel.fromJS(_data["porter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPorterViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetPorterViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        data["porter"] = this.porter ? this.porter.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPorterViewModel {
    fields?: GenericFieldDescription[];
    porter?: PorterViewModel;
}

export class PorterBudget implements IPorterBudget {
    porterNo?: string;
    typePoints?: boolean;
    typeEuros?: boolean;
    budgetAmountTotal?: number;
    budgetAmountRemaining?: number;
    budgetAmountUsed?: number;
    dateRenewed?: Date;

    constructor(data?: IPorterBudget) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.porterNo = _data["porterNo"];
            this.typePoints = _data["typePoints"];
            this.typeEuros = _data["typeEuros"];
            this.budgetAmountTotal = _data["budgetAmountTotal"];
            this.budgetAmountRemaining = _data["budgetAmountRemaining"];
            this.budgetAmountUsed = _data["budgetAmountUsed"];
            this.dateRenewed = _data["dateRenewed"] ? new Date(_data["dateRenewed"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PorterBudget {
        data = typeof data === 'object' ? data : {};
        let result = new PorterBudget();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["porterNo"] = this.porterNo;
        data["typePoints"] = this.typePoints;
        data["typeEuros"] = this.typeEuros;
        data["budgetAmountTotal"] = this.budgetAmountTotal;
        data["budgetAmountRemaining"] = this.budgetAmountRemaining;
        data["budgetAmountUsed"] = this.budgetAmountUsed;
        data["dateRenewed"] = this.dateRenewed ? this.dateRenewed.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPorterBudget {
    porterNo?: string;
    typePoints?: boolean;
    typeEuros?: boolean;
    budgetAmountTotal?: number;
    budgetAmountRemaining?: number;
    budgetAmountUsed?: number;
    dateRenewed?: Date;
}

export class GetPorterBudgetViewModel implements IGetPorterBudgetViewModel {
    budgets?: PorterBudget[];

    constructor(data?: IGetPorterBudgetViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["budgets"])) {
                this.budgets = [] as any;
                for (let item of _data["budgets"])
                    this.budgets!.push(PorterBudget.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPorterBudgetViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetPorterBudgetViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.budgets)) {
            data["budgets"] = [];
            for (let item of this.budgets)
                data["budgets"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPorterBudgetViewModel {
    budgets?: PorterBudget[];
}

export class GetPorterBudgetsByCustomerNumberViewModel implements IGetPorterBudgetsByCustomerNumberViewModel {
    budgets?: PorterBudget[];

    constructor(data?: IGetPorterBudgetsByCustomerNumberViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["budgets"])) {
                this.budgets = [] as any;
                for (let item of _data["budgets"])
                    this.budgets!.push(PorterBudget.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPorterBudgetsByCustomerNumberViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetPorterBudgetsByCustomerNumberViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.budgets)) {
            data["budgets"] = [];
            for (let item of this.budgets)
                data["budgets"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPorterBudgetsByCustomerNumberViewModel {
    budgets?: PorterBudget[];
}

export class PorterItemsSize implements IPorterItemsSize {
    variantNumber?: string;
    size?: string;
    subSize?: string;
    readonly isSubSize?: boolean;
    sizeSortingOrder?: number;
    subSizeSortingOrder?: number;
    itemNumber?: string;
    readonly variantSize?: string;

    constructor(data?: IPorterItemsSize) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.variantNumber = _data["variantNumber"];
            this.size = _data["size"];
            this.subSize = _data["subSize"];
            (<any>this).isSubSize = _data["isSubSize"];
            this.sizeSortingOrder = _data["sizeSortingOrder"];
            this.subSizeSortingOrder = _data["subSizeSortingOrder"];
            this.itemNumber = _data["itemNumber"];
            (<any>this).variantSize = _data["variantSize"];
        }
    }

    static fromJS(data: any): PorterItemsSize {
        data = typeof data === 'object' ? data : {};
        let result = new PorterItemsSize();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["variantNumber"] = this.variantNumber;
        data["size"] = this.size;
        data["subSize"] = this.subSize;
        data["isSubSize"] = this.isSubSize;
        data["sizeSortingOrder"] = this.sizeSortingOrder;
        data["subSizeSortingOrder"] = this.subSizeSortingOrder;
        data["itemNumber"] = this.itemNumber;
        data["variantSize"] = this.variantSize;
        return data;
    }
}

export interface IPorterItemsSize {
    variantNumber?: string;
    size?: string;
    subSize?: string;
    isSubSize?: boolean;
    sizeSortingOrder?: number;
    subSizeSortingOrder?: number;
    itemNumber?: string;
    variantSize?: string;
}

export class PorterKey implements IPorterKey {
    id?: string;

    constructor(data?: IPorterKey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PorterKey {
        data = typeof data === 'object' ? data : {};
        let result = new PorterKey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IPorterKey {
    id?: string;
}

export class PorterItem implements IPorterItem {
    porterKey?: PorterKey;
    readonly itemNo?: string;
    readonly adjustmentItem?: string;
    comment?: string;
    isOldModelSales?: boolean;
    replacementProductGroupCode?: string;
    replacementProductName?: string;
    quantityInUse?: number;
    id?: string;

    constructor(data?: IPorterItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.porterKey = _data["porterKey"] ? PorterKey.fromJS(_data["porterKey"]) : <any>undefined;
            (<any>this).itemNo = _data["itemNo"];
            (<any>this).adjustmentItem = _data["adjustmentItem"];
            this.comment = _data["comment"];
            this.isOldModelSales = _data["isOldModelSales"];
            this.replacementProductGroupCode = _data["replacementProductGroupCode"];
            this.replacementProductName = _data["replacementProductName"];
            this.quantityInUse = _data["quantityInUse"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PorterItem {
        data = typeof data === 'object' ? data : {};
        let result = new PorterItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["porterKey"] = this.porterKey ? this.porterKey.toJSON() : <any>undefined;
        data["itemNo"] = this.itemNo;
        data["adjustmentItem"] = this.adjustmentItem;
        data["comment"] = this.comment;
        data["isOldModelSales"] = this.isOldModelSales;
        data["replacementProductGroupCode"] = this.replacementProductGroupCode;
        data["replacementProductName"] = this.replacementProductName;
        data["quantityInUse"] = this.quantityInUse;
        data["id"] = this.id;
        return data;
    }
}

export interface IPorterItem {
    porterKey?: PorterKey;
    itemNo?: string;
    adjustmentItem?: string;
    comment?: string;
    isOldModelSales?: boolean;
    replacementProductGroupCode?: string;
    replacementProductName?: string;
    quantityInUse?: number;
    id?: string;
}

export class PorterItemViewModel implements IPorterItemViewModel {
    product?: ProductViewModel;
    porterItem?: PorterItem;

    constructor(data?: IPorterItemViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.product = _data["product"] ? ProductViewModel.fromJS(_data["product"]) : <any>undefined;
            this.porterItem = _data["porterItem"] ? PorterItem.fromJS(_data["porterItem"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PorterItemViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PorterItemViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["porterItem"] = this.porterItem ? this.porterItem.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPorterItemViewModel {
    product?: ProductViewModel;
    porterItem?: PorterItem;
}

export class GetPorterProductListItemsViewModel implements IGetPorterProductListItemsViewModel {
    readonly porterItemsSelectedSizes?: { [key: string]: PorterItemsSize[]; };
    readonly porterItemsMissingSize?: PorterItemViewModel[];
    readonly porterItemsAvailableSizes?: { [key: string]: PorterItemsSize[]; };
    readonly porterItems?: PorterItemViewModel[];

    constructor(data?: IGetPorterProductListItemsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["porterItemsSelectedSizes"]) {
                (<any>this).porterItemsSelectedSizes = {} as any;
                for (let key in _data["porterItemsSelectedSizes"]) {
                    if (_data["porterItemsSelectedSizes"].hasOwnProperty(key))
                        (<any>(<any>this).porterItemsSelectedSizes)![key] = _data["porterItemsSelectedSizes"][key] ? _data["porterItemsSelectedSizes"][key].map((i: any) => PorterItemsSize.fromJS(i)) : [];
                }
            }
            if (Array.isArray(_data["porterItemsMissingSize"])) {
                (<any>this).porterItemsMissingSize = [] as any;
                for (let item of _data["porterItemsMissingSize"])
                    (<any>this).porterItemsMissingSize!.push(PorterItemViewModel.fromJS(item));
            }
            if (_data["porterItemsAvailableSizes"]) {
                (<any>this).porterItemsAvailableSizes = {} as any;
                for (let key in _data["porterItemsAvailableSizes"]) {
                    if (_data["porterItemsAvailableSizes"].hasOwnProperty(key))
                        (<any>(<any>this).porterItemsAvailableSizes)![key] = _data["porterItemsAvailableSizes"][key] ? _data["porterItemsAvailableSizes"][key].map((i: any) => PorterItemsSize.fromJS(i)) : [];
                }
            }
            if (Array.isArray(_data["porterItems"])) {
                (<any>this).porterItems = [] as any;
                for (let item of _data["porterItems"])
                    (<any>this).porterItems!.push(PorterItemViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPorterProductListItemsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetPorterProductListItemsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.porterItemsSelectedSizes) {
            data["porterItemsSelectedSizes"] = {};
            for (let key in this.porterItemsSelectedSizes) {
                if (this.porterItemsSelectedSizes.hasOwnProperty(key))
                    (<any>data["porterItemsSelectedSizes"])[key] = (<any>this.porterItemsSelectedSizes)[key];
            }
        }
        if (Array.isArray(this.porterItemsMissingSize)) {
            data["porterItemsMissingSize"] = [];
            for (let item of this.porterItemsMissingSize)
                data["porterItemsMissingSize"].push(item.toJSON());
        }
        if (this.porterItemsAvailableSizes) {
            data["porterItemsAvailableSizes"] = {};
            for (let key in this.porterItemsAvailableSizes) {
                if (this.porterItemsAvailableSizes.hasOwnProperty(key))
                    (<any>data["porterItemsAvailableSizes"])[key] = (<any>this.porterItemsAvailableSizes)[key];
            }
        }
        if (Array.isArray(this.porterItems)) {
            data["porterItems"] = [];
            for (let item of this.porterItems)
                data["porterItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPorterProductListItemsViewModel {
    porterItemsSelectedSizes?: { [key: string]: PorterItemsSize[]; };
    porterItemsMissingSize?: PorterItemViewModel[];
    porterItemsAvailableSizes?: { [key: string]: PorterItemsSize[]; };
    porterItems?: PorterItemViewModel[];
}

export class GetPorterFunctionViewModel implements IGetPorterFunctionViewModel {
    functions?: string[];

    constructor(data?: IGetPorterFunctionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["functions"])) {
                this.functions = [] as any;
                for (let item of _data["functions"])
                    this.functions!.push(item);
            }
        }
    }

    static fromJS(data: any): GetPorterFunctionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetPorterFunctionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.functions)) {
            data["functions"] = [];
            for (let item of this.functions)
                data["functions"].push(item);
        }
        return data;
    }
}

export interface IGetPorterFunctionViewModel {
    functions?: string[];
}

export class UpdatePorterCommandArguments implements IUpdatePorterCommandArguments {
    key?: PorterKey;
    firstName?: string;
    lastName?: string;
    street?: string;
    city?: string;
    phone?: string;
    zip?: string;
    functionCode?: string;
    nonDismissable?: boolean;
    email?: string;
    readonly genericFields?: { [key: string]: any; };

    constructor(data?: IUpdatePorterCommandArguments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] ? PorterKey.fromJS(_data["key"]) : <any>undefined;
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.phone = _data["phone"];
            this.zip = _data["zip"];
            this.functionCode = _data["functionCode"];
            this.nonDismissable = _data["nonDismissable"];
            this.email = _data["email"];
            if (_data["genericFields"]) {
                (<any>this).genericFields = {} as any;
                for (let key in _data["genericFields"]) {
                    if (_data["genericFields"].hasOwnProperty(key))
                        (<any>(<any>this).genericFields)![key] = _data["genericFields"][key];
                }
            }
        }
    }

    static fromJS(data: any): UpdatePorterCommandArguments {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePorterCommandArguments();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key ? this.key.toJSON() : <any>undefined;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["street"] = this.street;
        data["city"] = this.city;
        data["phone"] = this.phone;
        data["zip"] = this.zip;
        data["functionCode"] = this.functionCode;
        data["nonDismissable"] = this.nonDismissable;
        data["email"] = this.email;
        if (this.genericFields) {
            data["genericFields"] = {};
            for (let key in this.genericFields) {
                if (this.genericFields.hasOwnProperty(key))
                    (<any>data["genericFields"])[key] = (<any>this.genericFields)[key];
            }
        }
        return data;
    }
}

export interface IUpdatePorterCommandArguments {
    key?: PorterKey;
    firstName?: string;
    lastName?: string;
    street?: string;
    city?: string;
    phone?: string;
    zip?: string;
    functionCode?: string;
    nonDismissable?: boolean;
    email?: string;
    genericFields?: { [key: string]: any; };
}

export class CreatePorterCommandArguments implements ICreatePorterCommandArguments {
    firstName?: string;
    lastName?: string;
    street?: string;
    city?: string;
    functionCode?: string;
    email?: string;
    nonDismissable?: boolean;
    readonly genericFields?: { [key: string]: any; };

    constructor(data?: ICreatePorterCommandArguments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.functionCode = _data["functionCode"];
            this.email = _data["email"];
            this.nonDismissable = _data["nonDismissable"];
            if (_data["genericFields"]) {
                (<any>this).genericFields = {} as any;
                for (let key in _data["genericFields"]) {
                    if (_data["genericFields"].hasOwnProperty(key))
                        (<any>(<any>this).genericFields)![key] = _data["genericFields"][key];
                }
            }
        }
    }

    static fromJS(data: any): CreatePorterCommandArguments {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePorterCommandArguments();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["street"] = this.street;
        data["city"] = this.city;
        data["functionCode"] = this.functionCode;
        data["email"] = this.email;
        data["nonDismissable"] = this.nonDismissable;
        if (this.genericFields) {
            data["genericFields"] = {};
            for (let key in this.genericFields) {
                if (this.genericFields.hasOwnProperty(key))
                    (<any>data["genericFields"])[key] = (<any>this.genericFields)[key];
            }
        }
        return data;
    }
}

export interface ICreatePorterCommandArguments {
    firstName?: string;
    lastName?: string;
    street?: string;
    city?: string;
    functionCode?: string;
    email?: string;
    nonDismissable?: boolean;
    genericFields?: { [key: string]: any; };
}

export class MovePorterCommandArguments implements IMovePorterCommandArguments {
    key?: PorterKey;
    moveToCustomerNumber?: string;
    firstName?: string;
    lastName?: string;
    street?: string;
    city?: string;
    functionCode?: string;
    nonDismissable?: boolean;
    languageCode?: string;
    readonly genericFields?: { [key: string]: any; };

    constructor(data?: IMovePorterCommandArguments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] ? PorterKey.fromJS(_data["key"]) : <any>undefined;
            this.moveToCustomerNumber = _data["moveToCustomerNumber"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.functionCode = _data["functionCode"];
            this.nonDismissable = _data["nonDismissable"];
            this.languageCode = _data["languageCode"];
            if (_data["genericFields"]) {
                (<any>this).genericFields = {} as any;
                for (let key in _data["genericFields"]) {
                    if (_data["genericFields"].hasOwnProperty(key))
                        (<any>(<any>this).genericFields)![key] = _data["genericFields"][key];
                }
            }
        }
    }

    static fromJS(data: any): MovePorterCommandArguments {
        data = typeof data === 'object' ? data : {};
        let result = new MovePorterCommandArguments();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key ? this.key.toJSON() : <any>undefined;
        data["moveToCustomerNumber"] = this.moveToCustomerNumber;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["street"] = this.street;
        data["city"] = this.city;
        data["functionCode"] = this.functionCode;
        data["nonDismissable"] = this.nonDismissable;
        data["languageCode"] = this.languageCode;
        if (this.genericFields) {
            data["genericFields"] = {};
            for (let key in this.genericFields) {
                if (this.genericFields.hasOwnProperty(key))
                    (<any>data["genericFields"])[key] = (<any>this.genericFields)[key];
            }
        }
        return data;
    }
}

export interface IMovePorterCommandArguments {
    key?: PorterKey;
    moveToCustomerNumber?: string;
    firstName?: string;
    lastName?: string;
    street?: string;
    city?: string;
    functionCode?: string;
    nonDismissable?: boolean;
    languageCode?: string;
    genericFields?: { [key: string]: any; };
}

export class GetPorterItemListViewModel implements IGetPorterItemListViewModel {
    readonly porterItems?: PorterItemViewModel[];

    constructor(data?: IGetPorterItemListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["porterItems"])) {
                (<any>this).porterItems = [] as any;
                for (let item of _data["porterItems"])
                    (<any>this).porterItems!.push(PorterItemViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPorterItemListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetPorterItemListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.porterItems)) {
            data["porterItems"] = [];
            for (let item of this.porterItems)
                data["porterItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPorterItemListViewModel {
    porterItems?: PorterItemViewModel[];
}

export class PorterItemKey implements IPorterItemKey {
    id?: string;

    constructor(data?: IPorterItemKey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PorterItemKey {
        data = typeof data === 'object' ? data : {};
        let result = new PorterItemKey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IPorterItemKey {
    id?: string;
}

export class UpdatePorterItemCommandArguments implements IUpdatePorterItemCommandArguments {
    porterItemKey?: PorterItemKey;
    comment?: string;

    constructor(data?: IUpdatePorterItemCommandArguments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.porterItemKey = _data["porterItemKey"] ? PorterItemKey.fromJS(_data["porterItemKey"]) : <any>undefined;
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): UpdatePorterItemCommandArguments {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePorterItemCommandArguments();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["porterItemKey"] = this.porterItemKey ? this.porterItemKey.toJSON() : <any>undefined;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IUpdatePorterItemCommandArguments {
    porterItemKey?: PorterItemKey;
    comment?: string;
}

export class DeletePorterItemCommandArguments implements IDeletePorterItemCommandArguments {
    key?: PorterItemKey;

    constructor(data?: IDeletePorterItemCommandArguments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] ? PorterItemKey.fromJS(_data["key"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DeletePorterItemCommandArguments {
        data = typeof data === 'object' ? data : {};
        let result = new DeletePorterItemCommandArguments();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key ? this.key.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDeletePorterItemCommandArguments {
    key?: PorterItemKey;
}

export class CreatePorterItemCommandArguments implements ICreatePorterItemCommandArguments {
    porterKey?: PorterKey;
    itemNo?: string;
    comment?: string;

    constructor(data?: ICreatePorterItemCommandArguments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.porterKey = _data["porterKey"] ? PorterKey.fromJS(_data["porterKey"]) : <any>undefined;
            this.itemNo = _data["itemNo"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): CreatePorterItemCommandArguments {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePorterItemCommandArguments();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["porterKey"] = this.porterKey ? this.porterKey.toJSON() : <any>undefined;
        data["itemNo"] = this.itemNo;
        data["comment"] = this.comment;
        return data;
    }
}

export interface ICreatePorterItemCommandArguments {
    porterKey?: PorterKey;
    itemNo?: string;
    comment?: string;
}

export class ReplacePorterItemCommandArguments implements IReplacePorterItemCommandArguments {
    porterKey?: PorterKey;
    oldItemNo?: string;
    newItemNo?: string;
    comment?: string;

    constructor(data?: IReplacePorterItemCommandArguments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.porterKey = _data["porterKey"] ? PorterKey.fromJS(_data["porterKey"]) : <any>undefined;
            this.oldItemNo = _data["oldItemNo"];
            this.newItemNo = _data["newItemNo"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): ReplacePorterItemCommandArguments {
        data = typeof data === 'object' ? data : {};
        let result = new ReplacePorterItemCommandArguments();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["porterKey"] = this.porterKey ? this.porterKey.toJSON() : <any>undefined;
        data["oldItemNo"] = this.oldItemNo;
        data["newItemNo"] = this.newItemNo;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IReplacePorterItemCommandArguments {
    porterKey?: PorterKey;
    oldItemNo?: string;
    newItemNo?: string;
    comment?: string;
}

export class GetPorterBudgetItemPricesCommandArguments implements IGetPorterBudgetItemPricesCommandArguments {
    porterUserName?: string;
    products?: ProductViewModel[];

    constructor(data?: IGetPorterBudgetItemPricesCommandArguments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.porterUserName = _data["porterUserName"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(ProductViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPorterBudgetItemPricesCommandArguments {
        data = typeof data === 'object' ? data : {};
        let result = new GetPorterBudgetItemPricesCommandArguments();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["porterUserName"] = this.porterUserName;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPorterBudgetItemPricesCommandArguments {
    porterUserName?: string;
    products?: ProductViewModel[];
}

export class GetPorterBudgetItemPrice implements IGetPorterBudgetItemPrice {
    no?: string;
    variant?: string;
    unit?: string;
    budgetPrice?: number;
    budgetPoints?: number;

    constructor(data?: IGetPorterBudgetItemPrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.no = _data["no"];
            this.variant = _data["variant"];
            this.unit = _data["unit"];
            this.budgetPrice = _data["budgetPrice"];
            this.budgetPoints = _data["budgetPoints"];
        }
    }

    static fromJS(data: any): GetPorterBudgetItemPrice {
        data = typeof data === 'object' ? data : {};
        let result = new GetPorterBudgetItemPrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["no"] = this.no;
        data["variant"] = this.variant;
        data["unit"] = this.unit;
        data["budgetPrice"] = this.budgetPrice;
        data["budgetPoints"] = this.budgetPoints;
        return data;
    }
}

export interface IGetPorterBudgetItemPrice {
    no?: string;
    variant?: string;
    unit?: string;
    budgetPrice?: number;
    budgetPoints?: number;
}

export class GetPorterBudgetItemPricesViewModel implements IGetPorterBudgetItemPricesViewModel {
    items?: GetPorterBudgetItemPrice[];

    constructor(data?: IGetPorterBudgetItemPricesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetPorterBudgetItemPrice.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPorterBudgetItemPricesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetPorterBudgetItemPricesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPorterBudgetItemPricesViewModel {
    items?: GetPorterBudgetItemPrice[];
}

export class ProductPriceKey implements IProductPriceKey {
    currencyKey?: ICurrencyKey;
    extraInfo?: { [key: string]: any; };
    productId?: string;
    variantId?: string;
    unitOfMeasure?: string;

    constructor(data?: IProductPriceKey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currencyKey = _data["currencyKey"] ? ICurrencyKey.fromJS(_data["currencyKey"]) : <any>undefined;
            if (_data["extraInfo"]) {
                this.extraInfo = {} as any;
                for (let key in _data["extraInfo"]) {
                    if (_data["extraInfo"].hasOwnProperty(key))
                        (<any>this.extraInfo)![key] = _data["extraInfo"][key];
                }
            }
            this.productId = _data["productId"];
            this.variantId = _data["variantId"];
            this.unitOfMeasure = _data["unitOfMeasure"];
        }
    }

    static fromJS(data: any): ProductPriceKey {
        data = typeof data === 'object' ? data : {};
        let result = new ProductPriceKey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencyKey"] = this.currencyKey ? this.currencyKey.toJSON() : <any>undefined;
        if (this.extraInfo) {
            data["extraInfo"] = {};
            for (let key in this.extraInfo) {
                if (this.extraInfo.hasOwnProperty(key))
                    (<any>data["extraInfo"])[key] = (<any>this.extraInfo)[key];
            }
        }
        data["productId"] = this.productId;
        data["variantId"] = this.variantId;
        data["unitOfMeasure"] = this.unitOfMeasure;
        return data;
    }
}

export interface IProductPriceKey {
    currencyKey?: ICurrencyKey;
    extraInfo?: { [key: string]: any; };
    productId?: string;
    variantId?: string;
    unitOfMeasure?: string;
}

export class GetPricesQueryArgs implements IGetPricesQueryArgs {
    keys?: ProductPriceKey[];

    constructor(data?: IGetPricesQueryArgs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["keys"])) {
                this.keys = [] as any;
                for (let item of _data["keys"])
                    this.keys!.push(ProductPriceKey.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPricesQueryArgs {
        data = typeof data === 'object' ? data : {};
        let result = new GetPricesQueryArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.keys)) {
            data["keys"] = [];
            for (let item of this.keys)
                data["keys"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPricesQueryArgs {
    keys?: ProductPriceKey[];
}

export class ICalculatedProductPrice implements IICalculatedProductPrice {
    unitPrice?: IPrice;
    netUnitPrice?: IPrice;
    readonly calculatedQuantityPrices?: { [key: string]: ICalculatedProductPrice; };
    currencyKey?: ICurrencyKey;
    readonly productId?: string;
    readonly variantId?: string;
    readonly unitOfMeasure?: string;
    readonly extraInfo?: { [key: string]: any; };

    constructor(data?: IICalculatedProductPrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unitPrice = _data["unitPrice"] ? IPrice.fromJS(_data["unitPrice"]) : <any>undefined;
            this.netUnitPrice = _data["netUnitPrice"] ? IPrice.fromJS(_data["netUnitPrice"]) : <any>undefined;
            if (_data["calculatedQuantityPrices"]) {
                (<any>this).calculatedQuantityPrices = {} as any;
                for (let key in _data["calculatedQuantityPrices"]) {
                    if (_data["calculatedQuantityPrices"].hasOwnProperty(key))
                        (<any>(<any>this).calculatedQuantityPrices)![key] = _data["calculatedQuantityPrices"][key] ? ICalculatedProductPrice.fromJS(_data["calculatedQuantityPrices"][key]) : new ICalculatedProductPrice();
                }
            }
            this.currencyKey = _data["currencyKey"] ? ICurrencyKey.fromJS(_data["currencyKey"]) : <any>undefined;
            (<any>this).productId = _data["productId"];
            (<any>this).variantId = _data["variantId"];
            (<any>this).unitOfMeasure = _data["unitOfMeasure"];
            if (_data["extraInfo"]) {
                (<any>this).extraInfo = {} as any;
                for (let key in _data["extraInfo"]) {
                    if (_data["extraInfo"].hasOwnProperty(key))
                        (<any>(<any>this).extraInfo)![key] = _data["extraInfo"][key];
                }
            }
        }
    }

    static fromJS(data: any): ICalculatedProductPrice {
        data = typeof data === 'object' ? data : {};
        let result = new ICalculatedProductPrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitPrice"] = this.unitPrice ? this.unitPrice.toJSON() : <any>undefined;
        data["netUnitPrice"] = this.netUnitPrice ? this.netUnitPrice.toJSON() : <any>undefined;
        if (this.calculatedQuantityPrices) {
            data["calculatedQuantityPrices"] = {};
            for (let key in this.calculatedQuantityPrices) {
                if (this.calculatedQuantityPrices.hasOwnProperty(key))
                    (<any>data["calculatedQuantityPrices"])[key] = this.calculatedQuantityPrices[key] ? this.calculatedQuantityPrices[key].toJSON() : <any>undefined;
            }
        }
        data["currencyKey"] = this.currencyKey ? this.currencyKey.toJSON() : <any>undefined;
        data["productId"] = this.productId;
        data["variantId"] = this.variantId;
        data["unitOfMeasure"] = this.unitOfMeasure;
        if (this.extraInfo) {
            data["extraInfo"] = {};
            for (let key in this.extraInfo) {
                if (this.extraInfo.hasOwnProperty(key))
                    (<any>data["extraInfo"])[key] = (<any>this.extraInfo)[key];
            }
        }
        return data;
    }
}

export interface IICalculatedProductPrice {
    unitPrice?: IPrice;
    netUnitPrice?: IPrice;
    calculatedQuantityPrices?: { [key: string]: ICalculatedProductPrice; };
    currencyKey?: ICurrencyKey;
    productId?: string;
    variantId?: string;
    unitOfMeasure?: string;
    extraInfo?: { [key: string]: any; };
}

export class GetPricesViewModel implements IGetPricesViewModel {
    readonly prices?: ICalculatedProductPrice[];

    constructor(data?: IGetPricesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["prices"])) {
                (<any>this).prices = [] as any;
                for (let item of _data["prices"])
                    (<any>this).prices!.push(ICalculatedProductPrice.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPricesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetPricesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.prices)) {
            data["prices"] = [];
            for (let item of this.prices)
                data["prices"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPricesViewModel {
    prices?: ICalculatedProductPrice[];
}

export class ProductMatrixViewModel implements IProductMatrixViewModel {
    productVariants?: ProductViewModel[];

    constructor(data?: IProductMatrixViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["productVariants"])) {
                this.productVariants = [] as any;
                for (let item of _data["productVariants"])
                    this.productVariants!.push(ProductViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductMatrixViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductMatrixViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productVariants)) {
            data["productVariants"] = [];
            for (let item of this.productVariants)
                data["productVariants"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProductMatrixViewModel {
    productVariants?: ProductViewModel[];
}

export class Shipment implements IShipment {
    readonly locationName?: string;
    readonly shipmentNumber?: string;
    readonly shipmentDate?: Date | undefined;
    readonly postingDate?: Date | undefined;
    readonly orderNo?: string;
    readonly yourReference?: string;
    readonly externalDocumentNo?: string;
    readonly customerName?: string;
    readonly customerName2?: string;
    readonly customerAddress?: string;
    readonly customerAddress2?: string;
    readonly customerPostCode?: string;
    readonly customerCity?: string;
    readonly customerContact?: string;
    readonly customerCountryCode?: string;
    readonly pricesOnDeliveryNote?: boolean;
    readonly salesMainDepartment?: string;

    constructor(data?: IShipment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).locationName = _data["locationName"];
            (<any>this).shipmentNumber = _data["shipmentNumber"];
            (<any>this).shipmentDate = _data["shipmentDate"] ? new Date(_data["shipmentDate"].toString()) : <any>undefined;
            (<any>this).postingDate = _data["postingDate"] ? new Date(_data["postingDate"].toString()) : <any>undefined;
            (<any>this).orderNo = _data["orderNo"];
            (<any>this).yourReference = _data["yourReference"];
            (<any>this).externalDocumentNo = _data["externalDocumentNo"];
            (<any>this).customerName = _data["customerName"];
            (<any>this).customerName2 = _data["customerName2"];
            (<any>this).customerAddress = _data["customerAddress"];
            (<any>this).customerAddress2 = _data["customerAddress2"];
            (<any>this).customerPostCode = _data["customerPostCode"];
            (<any>this).customerCity = _data["customerCity"];
            (<any>this).customerContact = _data["customerContact"];
            (<any>this).customerCountryCode = _data["customerCountryCode"];
            (<any>this).pricesOnDeliveryNote = _data["pricesOnDeliveryNote"];
            (<any>this).salesMainDepartment = _data["salesMainDepartment"];
        }
    }

    static fromJS(data: any): Shipment {
        data = typeof data === 'object' ? data : {};
        let result = new Shipment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationName"] = this.locationName;
        data["shipmentNumber"] = this.shipmentNumber;
        data["shipmentDate"] = this.shipmentDate ? this.shipmentDate.toISOString() : <any>undefined;
        data["postingDate"] = this.postingDate ? this.postingDate.toISOString() : <any>undefined;
        data["orderNo"] = this.orderNo;
        data["yourReference"] = this.yourReference;
        data["externalDocumentNo"] = this.externalDocumentNo;
        data["customerName"] = this.customerName;
        data["customerName2"] = this.customerName2;
        data["customerAddress"] = this.customerAddress;
        data["customerAddress2"] = this.customerAddress2;
        data["customerPostCode"] = this.customerPostCode;
        data["customerCity"] = this.customerCity;
        data["customerContact"] = this.customerContact;
        data["customerCountryCode"] = this.customerCountryCode;
        data["pricesOnDeliveryNote"] = this.pricesOnDeliveryNote;
        data["salesMainDepartment"] = this.salesMainDepartment;
        return data;
    }
}

export interface IShipment {
    locationName?: string;
    shipmentNumber?: string;
    shipmentDate?: Date | undefined;
    postingDate?: Date | undefined;
    orderNo?: string;
    yourReference?: string;
    externalDocumentNo?: string;
    customerName?: string;
    customerName2?: string;
    customerAddress?: string;
    customerAddress2?: string;
    customerPostCode?: string;
    customerCity?: string;
    customerContact?: string;
    customerCountryCode?: string;
    pricesOnDeliveryNote?: boolean;
    salesMainDepartment?: string;
}

export class ShipmentLine implements IShipmentLine {
    readonly shipmentLineNumber?: string;
    readonly itemNumber?: string;
    readonly description?: string;
    readonly quantity?: number;
    readonly unit?: string;
    readonly unitPrice?: string;
    readonly discountPercentage?: string;
    readonly weight?: string;
    readonly unitCode?: string;
    readonly porterNumber?: string;

    constructor(data?: IShipmentLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).shipmentLineNumber = _data["shipmentLineNumber"];
            (<any>this).itemNumber = _data["itemNumber"];
            (<any>this).description = _data["description"];
            (<any>this).quantity = _data["quantity"];
            (<any>this).unit = _data["unit"];
            (<any>this).unitPrice = _data["unitPrice"];
            (<any>this).discountPercentage = _data["discountPercentage"];
            (<any>this).weight = _data["weight"];
            (<any>this).unitCode = _data["unitCode"];
            (<any>this).porterNumber = _data["porterNumber"];
        }
    }

    static fromJS(data: any): ShipmentLine {
        data = typeof data === 'object' ? data : {};
        let result = new ShipmentLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shipmentLineNumber"] = this.shipmentLineNumber;
        data["itemNumber"] = this.itemNumber;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["unit"] = this.unit;
        data["unitPrice"] = this.unitPrice;
        data["discountPercentage"] = this.discountPercentage;
        data["weight"] = this.weight;
        data["unitCode"] = this.unitCode;
        data["porterNumber"] = this.porterNumber;
        return data;
    }
}

export interface IShipmentLine {
    shipmentLineNumber?: string;
    itemNumber?: string;
    description?: string;
    quantity?: number;
    unit?: string;
    unitPrice?: string;
    discountPercentage?: string;
    weight?: string;
    unitCode?: string;
    porterNumber?: string;
}

export enum DocumentType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export enum DocumentType2 {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export enum ScannedBarcodeState {
    None = "None",
    CUSEX = "CUSEX",
    CUSIN = "CUSIN",
    AFKEUR = "AFKEUR",
    CUSCHP = "CUSCHP",
}

export enum UpdateBarcodeListCommandArgumentsState {
    None = "None",
    CUSEX = "CUSEX",
    CUSIN = "CUSIN",
    AFKEUR = "AFKEUR",
    CUSCHP = "CUSCHP",
}

export enum ChangePorterByBarcodeCommandArgumentsState {
    None = "None",
    CUSEX = "CUSEX",
    CUSIN = "CUSIN",
    AFKEUR = "AFKEUR",
    CUSCHP = "CUSCHP",
}

export enum IOrderLineType {
    _0 = 0,
    _99 = 99,
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}